const _fc_props = {};
_fc_props.ante_meridiem = 'Prijepodne';
_fc_props.post_meridiem = 'Popodne';
_fc_props.retry = 'Pokušaj ponovo';
_fc_props.default = 'Zadano';
_fc_props.origin = 'Porijeklo';
_fc_props.day = 'Dan';
_fc_props.loading = 'Učitavanje';
_fc_props.list = 'Lista';
_fc_props.error = 'Greška';
_fc_props.save = 'Sačuvaj';
_fc_props.delete = 'Izbriši';
_fc_props.message = 'Poruka';
_fc_props.logout = 'Odjava';
_fc_props.add = 'Dodaj';
_fc_props.remove = 'Ukloni';
_fc_props.done = 'Gotovo';
_fc_props.other = 'Ostalo';
_fc_props.interval = 'Interval';
_fc_props.time = 'Vrijeme';
_fc_props.speed = 'Brzina';
_fc_props.longitude = 'Geografska dužina';
_fc_props.latitude = 'Geografska širina';
_fc_props.x_minutes = '{0} Min';
_fc_props.errors = 'Greške';
_fc_props.general = 'Općenito';
_fc_props.messages = 'Poruke';
_fc_props.gps_fixes = 'GPS popravke';
_fc_props.device_id = 'ID uređaja';
_fc_props.vehicle = 'Vozilo';
_fc_props.employee = 'Zaposlenik';
_fc_props.version = 'Verzija';
_fc_props.statuses = 'Statusi';
_fc_props.edit = 'Uredi';
_fc_props.cancel = 'Otkaži';
_fc_props.yes = 'Da';
_fc_props.none = 'Nijedan';
_fc_props.item = 'Stavka';
_fc_props.never = 'Nikad';
_fc_props.name = 'Ime';
_fc_props.average = 'Prosječno';
_fc_props.items = 'Stavke';
_fc_props.true = 'Tačno';
_fc_props.status = 'Status';
_fc_props.distance = 'Udaljenost';
_fc_props.ok = 'U redu';
_fc_props.login = 'Prijava';
_fc_props.next = 'Sljedeće';
_fc_props.info = 'Informacije';
_fc_props.menu = 'Meni';
_fc_props.not_available = 'Nije dostupno';
_fc_props.back = 'Nazad';
_fc_props.refresh = 'Osvježi';
_fc_props.select = 'Odaberite';
_fc_props.dispatch = 'Otprema';
_fc_props.messaging = 'Poruke';
_fc_props.plants = 'Biljke';
_fc_props.last_plants = 'Posljednje biljke';
_fc_props.vehicle_types = 'Tipovi vozila';
_fc_props.employee_types = 'Vrste zaposlenika';
_fc_props.employee_groups = 'Grupe zaposlenika';
_fc_props.equipment_groups = 'Grupe opreme';
_fc_props.status_type = 'Vrsta statusa';
_fc_props.job = 'Posao';
_fc_props.order = 'Narudžba';
_fc_props.ticket = 'Broj karte';
_fc_props.small = 'Mali';
_fc_props.medium = 'Srednji';
_fc_props.large = 'Veliko';
_fc_props.reports = 'Izvještaji';
_fc_props.payroll = 'Platni spisak';
_fc_props.support = 'Podrška';
_fc_props.username = 'Korisničko ime';
_fc_props.all = 'Svi';
_fc_props.question = 'Pitanje';
_fc_props.select_employee = 'Odaberite zaposlenika';
_fc_props.phone = 'Telefon';
_fc_props.january = 'Januar';
_fc_props.february = 'Februar';
_fc_props.march = 'Mart';
_fc_props.april = 'April';
_fc_props.may = 'Maj';
_fc_props.june = 'juni';
_fc_props.july = 'Juli';
_fc_props.august = 'Avgust';
_fc_props.september = 'Septembar';
_fc_props.october = 'Oktobar';
_fc_props.november = 'Novembar';
_fc_props.december = 'Decembar';
_fc_props.are_you_sure_you_want_to_delete = 'Jeste li sigurni da želite izbrisati';
_fc_props.unknown = 'Nepoznato';
_fc_props.invalid_date_range_report_is_limited_to_x_days = 'Nevažeći raspon datuma: Izvještaj je ograničen na {0} dana';
_fc_props.select_all = 'Odaberi sve';
_fc_props.resolution = 'Rezolucija';
_fc_props.equipment = 'Oprema';
_fc_props.totals = 'Ukupno';
_fc_props.region = 'Regija';
_fc_props.no_data = 'Nema podataka';
_fc_props.hotspot = 'Vruća tačka';
_fc_props.hotspot_type = 'Vrsta vruće tačke';
_fc_props.datetime = 'Datum/vrijeme';
_fc_props.address = 'Adresa';
_fc_props.retrieving_address = 'Preuzimanje adrese...';
_fc_props.address_not_found = 'Adresa nije pronađena';
_fc_props.active_time = 'Aktivno vrijeme';
_fc_props.destination_time = 'Vrijeme odredišta';
_fc_props.complete_time = 'Završeno vrijeme';
_fc_props.status_report = 'Izvještaj o statusu';
_fc_props.export_report = 'Izvoz izvještaja';
_fc_props.download_report = 'Preuzmi izvještaj';
_fc_props.view_report = 'Prikaži izvještaj';
_fc_props.duration = 'Trajanje';
_fc_props.min = 'Min.';
_fc_props.start_date_time = 'Datum/vrijeme početka';
_fc_props.select_start_date = 'Odaberite datum početka';
_fc_props.end_date_time = 'Datum/vrijeme završetka';
_fc_props.select_end_date = 'Odaberite datum završetka';
_fc_props.trip_time = 'Vrijeme putovanja';
_fc_props.travel_time = 'Vrijeme putovanja';
_fc_props.description = 'Opis';
_fc_props.map_controls = 'Kontrole mape';
_fc_props.road = 'Put';
_fc_props.aerial = 'Zračna luka';
_fc_props.hybrid = 'Hibrid';
_fc_props.trip = 'Putovanje';
_fc_props.map = 'Mapa';
_fc_props.plant = 'Biljka';
_fc_props.select_date = 'Odaberite datum';
_fc_props.apply = 'Primijeni';
_fc_props.save_settings = 'Sačuvaj postavke';
_fc_props.false = 'Netačno';
_fc_props.delete_confirmation = 'Potvrda brisanja';
_fc_props.last_name = 'Prezime';
_fc_props.none_selected = 'Nije odabrano';
_fc_props.start_date = 'Datum početka';
_fc_props.group_by = 'Grupiraj po';
_fc_props.equipment_employee = 'Oprema / Zaposlenik';
_fc_props.inactive = 'Neaktivno';
_fc_props.active = 'Aktivno';
_fc_props.note_checking_may_affect_performance = 'Napomena: Provjera može utjecati na performanse';
_fc_props.show_distancefuel_used = 'Prikaži udaljenost/potrošeno gorivo';
_fc_props.mins = 'Minuta';
_fc_props.threshold_time = 'Vrijeme praga';
_fc_props.include_voided_tickets = 'Uključi poništene karte';
_fc_props.note_all_times_listed_are_in_minutes = 'Napomena: Sva navedena vremena su u minutama';
_fc_props.please_select_a_job_order_or_equipment = 'Molimo odaberite posao, narudžbu, postrojenje, opremu ili zaposlenika';
_fc_props.device = 'Uređaj';
_fc_props.select_equipment = 'Odaberite opremu';
_fc_props.on_enter = 'Pri ulasku';
_fc_props.on_exit = 'Na izlazu';
_fc_props.all_equipment_types = 'Sve vrste opreme';
_fc_props.summary = 'Sažetak';
_fc_props.units = {};
_fc_props.units.liters = 'Litre';
_fc_props.type = 'Tip';
_fc_props.no_data_available = 'Nema dostupnih podataka';
_fc_props.menu = {};
_fc_props.menu.reports = {};
_fc_props.menu.reports.title = {};
_fc_props.menu.reports.title.breakdown = 'Raspored';
_fc_props.menu.reports.title.distance_and_fuel_by_region = 'Udaljenost i gorivo po regiji';
_fc_props.menu_settings_title_settings = 'Postavke';
_fc_props.menu_settings_title_alerts = 'Obavještenja';
_fc_props.menu.settings = {};
_fc_props.menu.settings.title = {};
_fc_props.menu.settings.title.equipment = 'Oprema';
_fc_props.menu_settings_title_hotspots_regions = 'Žaruće tačke i regije';
_fc_props.days = '{0} dan(a)';
_fc_props.home = 'Dom';
_fc_props.find = 'Pronađi';
_fc_props.close_this_panel = 'zatvori ovaj panel';
_fc_props.filters = 'Filteri';
_fc_props.start = 'Početak';
_fc_props.end = 'Kraj';
_fc_props.location_details = 'Detalji lokacije';
_fc_props.first_name = 'Ime';
_fc_props.material_per_hour = 'Materijal po satu';
_fc_props.equipment_pound = 'Oprema #';
_fc_props.equipment_type = 'Vrsta opreme';
_fc_props.options = 'Opcije';
_fc_props.zoom_on_cursor_position = 'Zumiraj na poziciji kursora';
_fc_props.display_equipment_identifier = 'Identifikator opreme za prikaz';
_fc_props.view_equipment = 'Pogledajte opremu';
_fc_props.view_hotspots = 'Pogledajte vruće tačke';
_fc_props.view_regions = 'Prikaži regije';
_fc_props.use_standard_filters = 'Koristite standardne filtere';
_fc_props.home_plant = 'Kućna biljka';
_fc_props.last_plant = 'Posljednja biljka';
_fc_props.equip_types = 'Vrste opreme';
_fc_props.equip_groups = 'Opremanje grupa';
_fc_props.orders = 'Narudžbe';
_fc_props.trakitall = 'TrakitALL';
_fc_props.use_equipment_filter = 'Koristite filter opreme';
_fc_props.all_selected = 'Sve odabrano';
_fc_props.of = 'Od';
_fc_props.your_map_session_has_expired = 'Vaša sesija mapiranja je istekla. Molimo osvježite stranicu.';
_fc_props.equipment_short = 'Opremi.';
_fc_props.job_info_for = 'Informacije o poslu za';
_fc_props.order_info_for = 'Informacije o narudžbi za';
_fc_props.ticket_info_for_vehicle = 'Informacije o kazni za vozilo';
_fc_props.inbox = 'Pristigla pošta';
_fc_props.outbox = 'Poslano';
_fc_props.alerts = 'Obavještenja';
_fc_props.critical = 'Kritično';
_fc_props.important = 'Važno';
_fc_props.informational = 'Informativno';
_fc_props.customer = 'Kupac';
_fc_props.view_routes = 'Pogledajte rute';
_fc_props.hours_size = 'Veličina sati';
_fc_props.used_count = 'Broj korištenih';
_fc_props.last_login = 'Posljednja prijava';
_fc_props.last_vehicle = 'Posljednje vozilo';
_fc_props.regions = 'Regije';
_fc_props.employee_type = 'Vrsta zaposlenika';
_fc_props.driver = 'Vozač';
_fc_props.js_delete = 'Izbriši';
_fc_props.move = 'Pomakni se';
_fc_props.edit_hotspot = 'Uredi vruću tačku';
_fc_props.adjust_shape = 'Prilagodi oblik';
_fc_props.edit_region = 'Uredi regiju';
_fc_props.enter_a_start_address = 'Molimo unesite početnu adresu';
_fc_props.select_a_start_hotspot = 'Molimo odaberite početnu pristupnu tačku';
_fc_props.failed_to_find_start_hotspot = 'Nije moguće pronaći početnu pristupnu tačku.';
_fc_props.invalid_latitudelongitude = 'Nevažeća geografska širina/dužina';
_fc_props.enter_an_end_address = 'Molimo unesite krajnju adresu';
_fc_props.select_an_end_hotspot = 'Molimo odaberite krajnju žarišnu tačku';
_fc_props.failed_to_find_end_hotspot = 'Nije moguće pronaći krajnju pristupnu tačku.';
_fc_props.print = 'Štampaj';
_fc_props.these_directions_are_for_informational_purposes = 'Ova uputstva su samo u informativne svrhe. Ne garantujemo njihovu potpunost ili tačnost. Građevinski projekti, saobraćaj ili drugi događaji mogu uzrokovati da se stvarni uslovi razlikuju od ovih rezultata.';
_fc_props.enter_an_address = 'Molimo unesite adresu';
_fc_props.select_a_hotspot = 'Molimo odaberite pristupnu tačku';
_fc_props.failed_to_find_hotspot = 'Nije moguće pronaći pristupnu tačku.';
_fc_props.select_a_vehicle = 'Molimo odaberite vozilo';
_fc_props.failed_to_find_vehicle = 'Nije moguće pronaći vozilo.';
_fc_props.failed_to_find_address = 'Nije pronađena adresa';
_fc_props.failed_to_find_vehicles = 'Nije moguće pronaći vozila prema kriterijima pretrage.';
_fc_props.get_address = 'Dobij adresu';
_fc_props.results_for = 'Rezultati za';
_fc_props.error_retrieving_results = 'Greška pri preuzimanju rezultata';
_fc_props.no_results_found = 'Nisu pronađeni rezultati';
_fc_props.address_is_required = 'Adresa je obavezna';
_fc_props.city_is_required = 'Grad je obavezan';
_fc_props.set_location = 'Postavi lokaciju';
_fc_props.set_area_of_interest = 'Postavi područje interesa';
_fc_props.center_map_here = 'Centriraj mapu ovdje';
_fc_props.zoom_to_street_level = 'Zumiraj na nivo ulice';
_fc_props.set_start = 'Postavi početak';
_fc_props.set_end = 'Postavi kraj';
_fc_props.delete_node = 'Obriši čvor';
_fc_props.create_a_hotspot = 'Kreiraj vruću tačku';
_fc_props.create_a_region = 'Kreiraj regiju';
_fc_props.toggle_shapes = 'Uključi/isključi oblike';
_fc_props.refresh_map = 'Osvježi mapu';
_fc_props.more_options = 'Više opcija';
_fc_props.recenter_map = 'Ponovo centriraj mapu';
_fc_props.zoom_to_vehicle = 'Zumiraj na vozilo';
_fc_props.apply_filters = 'Primijeni filtere';
_fc_props.grid_view = 'Prikaz mreže';
_fc_props.list_view = 'Prikaz liste';
_fc_props.click_to_sort = 'Kliknite za sortiranje';
_fc_props.message_history = 'Historija poruka';
_fc_props.equipment_types = 'Vrste opreme';
_fc_props.send_message = 'Pošalji poruku';
_fc_props.last_load = 'Posljednje utovar';
_fc_props.last_load_on = 'Posljednje učitavanje uključeno';
_fc_props.manual_logout = 'Ručna odjava';
_fc_props.manual_login = 'Ručna prijava';
_fc_props.no_employees_logged_in = 'Nema prijavljenih zaposlenika';
_fc_props.select_phone = 'Odaberite telefon';
_fc_props.you_must_select_a_phone = 'Morate odabrati telefon, opremu i zaposlenika';
_fc_props.are_you_sure_you_want_to_logout = 'Jeste li sigurni da se želite odjaviti';
_fc_props.fix_time = 'Vrijeme popravke';
_fc_props.to_next_fix = 'do sljedećeg popravka';
_fc_props.minutes_to_next_fix = 'Minute do sljedećeg popravka';
_fc_props.liters = 'Litre';
_fc_props.destination = 'Odredište';
_fc_props.return = 'Povratak';
_fc_props.product = 'Proizvod';
_fc_props.no_records_found = 'Nije pronađen nijedan zapis.';
_fc_props.vehicle_type = 'Tip vozila';
_fc_props.view_in_map = 'Prikaži sve na mapi';
_fc_props.uploads = 'Otpremanja';
_fc_props.upload_csv_file = 'Otpremi CSV datoteku';
_fc_props.permanent = 'Trajno';
_fc_props.expire_time = 'Vrijeme isteka';
_fc_props.please_select_x_for_tickets_marked_active = 'Molimo odaberite {0} za karte označene kao AKTIVNE';
_fc_props.multiple_tickets_marked_active_for_same_x = 'Više tiketa označenih kao AKTIVNI za isti {0}';
_fc_props.delivery_time = 'Vrijeme isporuke';
_fc_props.failure_connecting_to_servlet = 'Greška pri povezivanju sa servletom.';
_fc_props.status_time_summary = 'Sažetak vremena statusa';
_fc_props.view_in_map_one = 'Prikaži na mapi';
_fc_props.question_report = 'Izvještaj o pitanju';
_fc_props.end_date = 'Datum završetka';
_fc_props.trailer_number = 'Broj prikolice';
_fc_props.region_panel = 'Regionalni panel';
_fc_props.hotspot_panel = 'Panel vrućih tačaka';
_fc_props.shape = 'Oblik';
_fc_props.circle = 'Krug';
_fc_props.polygon = 'Poligon';
_fc_props.click_the_map_to_set_the_location = 'Kliknite na mapu da biste postavili željenu lokaciju.';
_fc_props.click_the_map_to_set_the_hotspot_center = 'Kliknite na mapu da biste postavili centar žarišne tačke.';
_fc_props.click_the_map_to_set_the_region_center = 'Kliknite na mapu da biste postavili centar regije.';
_fc_props.click_and_drag_points = 'Kliknite i prevucite tačke da biste uredili oblik. Kliknite SAČUVAJ da biste sačuvali promjene.';
_fc_props.size = 'Veličina';
_fc_props.are_you_sure_you_want_to_move_this = 'Jeste li sigurni da želite ovo premjestiti';
_fc_props.are_you_sure_you_want_to_delete_this = 'Jeste li sigurni da želite ovo izbrisati';
_fc_props.please_enter_a_valid_size = 'Molimo unesite važeću veličinu';
_fc_props.failed_to_save = 'Spremanje nije uspjelo.';
_fc_props.failed_to_move = 'Premještanje nije uspjelo.';
_fc_props.failed_to_delete = 'Brisanje nije uspjelo.';
_fc_props.x_hours = '{0} sati';
_fc_props.hide_hotspots = 'Sakrij vruće tačke';
_fc_props.show_regions = 'Prikaži regije';
_fc_props.show_hotspots = 'Prikaži vruće tačke';
_fc_props.hide_regions = 'Sakrij regije';
_fc_props.numeric = 'Numerički';
_fc_props.message_type = 'Vrsta poruke';
_fc_props.text = 'Tekst';
_fc_props.yes_no = 'Da/Ne';
_fc_props.responses = 'Odgovori';
_fc_props.disabled = 'Onemogućeno';
_fc_props.group_name = 'Naziv grupe';
_fc_props.start_timer = 'Pokreni tajmer';
_fc_props.stop_timer = 'Zaustavi tajmer';
_fc_props.are_you_sure_you_want_to_delete_the_x_format = 'Jeste li sigurni da želite izbrisati format \'{0}\'?';
_fc_props.phone_number = 'Broj telefona';
_fc_props.interface_pound = 'Interfejs #';
_fc_props.field = 'Polje';
_fc_props.default_label = 'Zadana oznaka';
_fc_props.custom_label = 'Prilagođena oznaka';
_fc_props.you_must_enter_a_label = 'Morate unijeti oznaku.';
_fc_props.enabled = 'Omogućeno';
_fc_props.settings = {};
_fc_props.settings.ticket_integration = 'Integracija tiketa';
_fc_props.settings.geofence_off_open_hotspots = 'Geofence izvan otvorenih vrućih tačaka';
_fc_props.settings.associate_open_hotspots_wticket = 'Poveži otvorene pristupne tačke sa kartom';
_fc_props.settings.allow_geofencing_off_of_open_hotspots_or_only_hotspots_associated_with_drivers_ticket = 'Dozvoli geofencing izvan otvorenih žarišnih tačaka ili samo žarišnih tačaka povezanih s vozačkom kaznom';
_fc_props.settings.whether_or_not_to_associate_open_hotspots_with_tickets_when_a_vehicle_enters_them = 'Da li povezati otvorene vruće tačke sa kartama kada vozilo uđe u njih';
_fc_props.settings.void_ticket_without_destination = 'Nevažeća karta bez odredišta';
_fc_props.settings.if_a_ticket_is_received_while_another_one_is_active_if_the_active_ticket_does = 'Ako se karta primi dok je druga aktivna, a aktivna karta nema odredište, karta će biti poništena.';
_fc_props.settings.autocreate_hotspots = 'Automatsko kreiranje vrućih tačaka';
_fc_props.settings.whether_or_not_to_automatically_create_hotspots_from_the_destination = 'Da li da se automatski kreiraju vruće tačke sa odredišne adrese kada se primi tiket';
_fc_props.settings.autoactivate_ticket_upon_receive = 'Automatska aktivacija karte po prijemu';
_fc_props.settings.is_the_ticket_active_when_it_is_received_by_trackit_default_true = 'Da li je karta aktivna kada je TrackIt primi (zadano \'true\')';
_fc_props.settings.auto_close_active_ticket_upon_receive_minutes = 'Automatsko zatvaranje aktivnog tiketa nakon prijema minuta';
_fc_props.settings.how_long_does_the_current_active_ticket_need_to_have_been_active_before = 'Koliko dugo trenutna aktivna karta mora biti aktivna prije nego što se automatski zatvori (zadano \'\')';
_fc_props.settings.ticket_max_activate_age_minutes = 'Maksimalna aktivna dob za kartu (minute)';
_fc_props.settings.how_old_in_minutes_can_a_ticket_be_when_activating_it_in_trackit_default_ = 'Koliko star tiket može biti u minutama prilikom aktiviranja u TrackIt-u (zadano \'\')';
_fc_props.settings.max_hotspot_unused_days = 'Maksimalan broj neiskorištenih dana za vruću tačku';
_fc_props.settings.sets_the_max_days_a_hotspot_can_be_unused_and_still_be_revived = 'Postavlja maksimalan broj dana koliko se Hotspot može ne koristiti, a ipak biti oživljen';
_fc_props.settings.radius_multiplier = 'Množitelj radijusa';
_fc_props.settings.what_to_multiply_the_radius_by_when_a_ticket_is_received_from_the = 'Čime pomnožiti radijus kada se karta primi od dispečerskog sistema?';
_fc_props.settings.ticket_message_date_format = 'Format datuma poruke tiketa';
_fc_props.am = 'sam';
_fc_props.pm = 'poslijepodne';
_fc_props.settings.ticket_message = 'Poruka o tiketu';
_fc_props.settings.add_ticket_element = 'Dodaj element karte';
_fc_props.driver_performance = 'Performanse vozača';
_fc_props.update_failed_can_not_connect = 'Ažuriranje nije uspjelo: Nije moguće povezati se sa servletom.';
_fc_props.company = 'Kompanija';
_fc_props.unknown_error = 'Nepoznata greška';
_fc_props.selected = 'Odabrano';
_fc_props.web_service = 'Web servis';
_fc_props.error_processing_request = 'Greška prilikom obrade zahtjeva.';
_fc_props.email_address = 'Adresa e-pošte';
_fc_props.id = 'ID';
_fc_props.last_used = 'Posljednje korištenje';
_fc_props.error_invalid_vehiclenum = 'Greška Nevažeći broj vozila';
_fc_props.error_vehicle_is_not_logged_in = 'Greška: Vozilo nije prijavljeno.';
_fc_props.status_timer = 'Tajmer statusa';
_fc_props.warning = 'Upozorenje';
_fc_props.users = 'Korisnici';
_fc_props.you_dont_have_access_to_this_page = 'Nemate pristup za pregled ove stranice. Molimo kontaktirajte svog sistem administratora za pristup.';
_fc_props.previous_week = 'Prethodna sedmica';
_fc_props.status_breakdown = 'Pregled statusa';
_fc_props.select_plant_or_employee_group = 'Morate odabrati ili pogon ili grupu zaposlenika.';
_fc_props.cannot_select_plant_and_employee_group = 'Ne možete odabrati i postrojenje i grupu zaposlenika.';
_fc_props.odometer_must_be_a_number = 'Početni broj kilometara mora biti broj';
_fc_props.ending_odometer_must_be_a_number = 'Konačni broj kilometara mora biti broj';
_fc_props.beginning_hour_meter_must_be_a_number = 'Početni broj sati mora biti broj';
_fc_props.ending_hour_meter_must_be_a_number = 'Završni brojač sati mora biti broj';
_fc_props.error_loading_status_change_page = 'Greška pri učitavanju stranice za promjenu statusa.';
_fc_props.x_is_an_invalid_time_format = '{0} je nevažeći format vremena, mora biti GGGG-MM-DD HH:MM:SS';
_fc_props.x_for_schedule_login = '{0} za zakazivanje prijave';
_fc_props.x_for_schedule_logout = '{0} za zakazivanje odjave';
_fc_props.x_for_actual_login = '{0} za stvarnu prijavu';
_fc_props.x_for_actual_logout = '{0} za stvarnu odjavu';
_fc_props.by_refreshing_the_time_card_detail = 'Osvježavanjem detalja kartice radnog vremena izgubit ćete sve promjene, želite li nastaviti?';
_fc_props.are_you_sure_you_want_to_delete_0 = 'Jeste li sigurni da želite izbrisati {0}?';
_fc_props.settings.command_mobile_ticket_url = 'URL adresa mobilnog tiketa Command';
_fc_props.year = 'Godina';
_fc_props.make = 'Napravite';
_fc_props.model = 'Model';
_fc_props.settings.command_mobile_ticket_password = 'Lozinka za Command Mobile Ticket';
_fc_props.settings.command_mobile_ticket_auth_token = 'Token za autorizaciju mobilnih karata Command';
_fc_props.target = 'Meta';
_fc_props.number_of_digits = 'Broj cifara';
_fc_props.number_of_integer_digits = 'Broj cijelih brojeva';
_fc_props.number_of_fractional_digits = 'Broj razlomljenih cifara';
_fc_props.search = 'Pretraga';
_fc_props.settings.command_mobile_ticket_date_order = 'Datum narudžbe karata za komandu Mobile';
_fc_props.settings.command_mobile_ticket_date_length = 'Trajanje datuma mobilnog tiketa Command Mobile';
_fc_props.settings.command_mobile_ticket_date_separator = 'Razdjelnik datuma tiketa Command Mobile';
_fc_props.settings.command_mobile_ticket_slash = '/ (kosa crta)';
_fc_props.settings.command_mobile_ticket_dash = '- (crtica)';
_fc_props.settings.command_mobile_ticket_period = '. (tačka)';
_fc_props.settings.command_mobile_ticket_space = '(razmak)';
_fc_props.settings.command_mobile_ticket_time_length = 'Trajanje vremenskog perioda za mobilne tikete komande';
_fc_props.settings.command_mobile_ticket_time_separator = 'Razdjelnik vremena tiketa Command Mobile';
_fc_props.settings.command_mobile_ticket_colon = ': (dvotačka)';
_fc_props.settings.command_mobile_ticket_time_format = 'Format vremena tiketa Command Mobile';
_fc_props.settings.command_mobile_ticket_use_interface_number = 'Koristi broj interfejsa';
_fc_props.language = 'Jezik';
_fc_props.mechanic = 'Mehaničar';
_fc_props.settings.command_mobile_ticket_poll_interval = 'Interval ankete (sekunde)';
_fc_props.driving_time = 'Vrijeme vožnje';
_fc_props.find_near_plants = 'Pronađi biljke u blizini';
_fc_props.please_create_hot_spot_first = 'Prvo kreirajte hotspot';
_fc_props.pump = 'Pumpa';
_fc_props.please_enter_hot_spot_description = 'Molimo unesite opis vruće tačke';
_fc_props.please_select_a_hot_spot_type = 'Molimo odaberite vrstu žarišne tačke';
_fc_props.settings.command_mobile_ticket_send_driver_email = 'Pošalji e-poruku vozaču';
_fc_props.directions_not_found = 'Nevažeća {0} adresa. Upute nisu pronađene.';
_fc_props.ws_user = 'Korisnik';
_fc_props.ws_service = 'Usluga';
_fc_props.ws_method = 'Metoda';
_fc_props.ws_params = 'Parametri';
_fc_props.units_kilometers_abbr = 'KM';
_fc_props.units_miles_abbr = 'MI';
_fc_props.origin_and_destination = 'Porijeklo i odredište';
_fc_props.liter_abbr = 'l';
_fc_props.help = 'Pomoć';
_fc_props.settings.command_mobile_ticket_use_alt_emp_number = 'Android Koristite alternativni broj zaposlenika';
_fc_props.settings.command_mobile_ticket_android_url = 'URL za mobilne karte za Android';
_fc_props.settings.command_mobile_ticket_android_secret = 'Tajna mobilnih karata za Android';
_fc_props.employee_x_has_no_logout_on_y = 'Zaposlenik {0} se ne može odjaviti za smjenu koja počinje {1}.';
_fc_props.phone_number_has_duplicates = 'Brojevi telefona imaju duplikate';
_fc_props.ounce = 'Unca';
_fc_props.water_extra = 'Dodatna voda';
_fc_props.always = 'Uvijek';
_fc_props.work_types_must_be_unique = 'Vrste poslova moraju biti jedinstvene';
_fc_props.manufacturer = 'Proizvođač';
_fc_props.need_to_enter_seconds = 'Potrebno je unijeti sekunde.';
_fc_props.copy = 'Kopiraj';
_fc_props.create_in_existing_required = 'Za kreiranje roaming hotspota mora biti odabrano "Kreiraj u postojećem".';
_fc_props.break = 'Pauza';
_fc_props.add_export_data_type = 'Dodaj tip podataka za izvoz';
_fc_props.edit_export_data_type = 'Uredi tip podataka za izvoz';
_fc_props.delete_export_data_type = 'Obriši tip podataka za izvoz';
_fc_props.export_data_type = 'Tip podataka za izvoz';
_fc_props.error_updating_export_data_type = 'Greška pri ažuriranju tipa izvoznih podataka';
_fc_props.settings.address_key = 'Ključ adrese';
_fc_props.settings.address_key_hover = 'Opcije ključa adrese';
_fc_props.settings.address_key_options = 'Opcije ključa adrese';
_fc_props.more_filter_options = 'Više opcija filtera';
_fc_props.unauthorized_mapit_app = 'Ova verzija MapIt-a nije autorizovana, molimo vas da ažurirate MapIt što je prije moguće.';
_fc_props.zello_timeout = 'Došlo je do isteka vremena prilikom kontaktiranja Zello-a.';
_fc_props.user_agreement_text = 'Prijavom prihvatate';
_fc_props.user_agreement = 'korisnički ugovor';
_fc_props.upload = 'Otpremi';
_fc_props.x_mins_left = 'Preostalo je {0} minuta';
_fc_props.continuous_location_tracking_colon = 'Neprekidno praćenje lokacije:';
_fc_props.hired_hauler_cannot_register_device = 'Unajmljeni prevoznik ne može registrovati novi uređaj.';
_fc_props.timecard_does_not_contain_shift = 'Kartica radnog vremena zaposlenika ne sadrži navedenu smjenu (informacije o kartici radnog vremena)';
_fc_props.timecard_not_found = 'Kartica radnog vremena zaposlenika nije pronađena';
_fc_props.vehicle_must_be_assigned_for_clt = 'Vozilo mora biti dodijeljeno lokacijama na traci.';
_fc_props.vehicle_unassigned_continuous_tracking_disabled = 'Vozilu je oduzeto dodjeljivanje, kontinuirano praćenje će biti onemogućeno.';
_fc_props.units_yards_abbr = 'YD';
_fc_props.units_meters_abbr = 'M';
_fc_props.error_lost_edc_connection = 'Izgubljena je veza s telematskim uređajem. Molimo provjerite jesu li vam omogućeni WiFi i/ili Bluetooth.';
_fc_props.acknowledge_all = 'Potvrdi sve';
_fc_props.expand = 'Proširi';
_fc_props.collapse = 'Sažmi';
_fc_props.expand_all = 'Proširi sve';
_fc_props.collapse_all = 'Sažmi sve';
_fc_props.last_update = 'Posljednje ažuriranje';
_fc_props.acknowledge_alert = 'Potvrdi upozorenje';
_fc_props.acknowledge_message = 'Potvrdi poruku';
_fc_props.acknowledge_all_alerts = 'Potvrdi sva upozorenja';
_fc_props.acknowledge_all_messages = 'Potvrdi sve poruke';
_fc_props.eta = 'Očekivano vrijeme dolaska';
_fc_props.tolerance_must_be_a_valid_integer = 'Tolerancija mora biti važeći cijeli broj između -99 i 99 (uključujući oba)';
_fc_props.gps_permission_required = 'Potrebna je dozvola za GPS';
_fc_props.permissions_required = 'Potrebne dozvole';
_fc_props.change_user = 'Promijeni korisnika';
_fc_props.account_not_registered_with_carrier = 'Ovaj račun nije registrovan kod operatera';
_fc_props.slump_loss = 'Gubitak u padu';
_fc_props.slump_loss_help = 'Pomoć kod gubitka sloma';
_fc_props.did_not_receive_any_edc_devices = 'Nisam primio/la nijedan uređaj.';
_fc_props.edc_record_not_found = 'Zapis telematskog uređaja nije pronađen';
_fc_props.disable_hotspot_prompt = 'Molimo vas da dodirnete "U redu" kada se od vas zatraži da deaktivirate svoju pristupnu tačku.';
_fc_props.edc_device_is_in_use = 'Telematski uređaj {0} je u upotrebi.';
_fc_props.an_unknown_exception_has_occurred = 'Došlo je do nepoznatog izuzetka';
_fc_props.login_has_timed_out = 'Vrijeme za prijavu je isteklo';
_fc_props.use_paper_logs = 'Koristite papirne zapisnike';
_fc_props.eld_login_failed = 'Prijava na radno vrijeme nije uspjela';
_fc_props.setup_time_off_type = 'Molimo postavite vrstu slobodnog vremena.';
_fc_props.view_load_properties = 'Prikaz svojstava opterećenja';
_fc_props.couldnt_download_edc_firmware = 'Nije moguće preuzeti firmver telematskog uređaja.';
_fc_props.password_incorrect = 'Lozinka je netačna';
_fc_props.edc_configuration_password_prompt = 'Zbog stanja ovog uređaja, morate unijeti lozinku instalatera za konfiguraciju.';
_fc_props.edc_configuration_check_failed = 'Validacija zapisa telematskog servera uređaja nije uspjela. Molimo provjerite poruke o grešci za detalje.';
_fc_props.configuration_issues_prompt = 'Sljedeći problemi su otkriveni prilikom konfigurisanja odabranog telematskog uređaja za određeni kamion';
_fc_props.checking_password = 'Provjera lozinke';
_fc_props.reset_password_instructions_sent = 'Upute za resetiranje lozinke poslane su na adresu e-pošte {0}.';
_fc_props.reset_password_failed = 'Resetiranje lozinke nije uspjelo, pokušajte ponovo.';
_fc_props.forgot_password = 'Zaboravljena lozinka?';
_fc_props.enter_valid_email = 'Nevažeća adresa e-pošte, unesite važeću adresu e-pošte i pokušajte ponovo.';
_fc_props.issues_while_updating_edc_record = 'Telematski uređaj je uspješno konfiguriran. Međutim, postoje problemi sa zapisima za uređaj na TrackIt serveru koji mogu uzrokovati da ne funkcionira. Molimo vas da pozovete podršku kako biste ispravili informacije.';
_fc_props.sending = 'Slanje...';
_fc_props.minimum_ratio = 'Minimalni omjer';
_fc_props.vin = 'VIN';
_fc_props.probe_rpm_not_in_range = 'Broj okretaja bubnja nije u rasponu';
_fc_props.probe_failure = 'Kvar sonde';
_fc_props.unknown_probe_data_failure = 'Nepoznata greška u podacima sonde';
_fc_props.no_loaded_status_meaning = 'Status nije učitan';
_fc_props.no_depart_status_meaning = 'Nema statusa odlaska';
_fc_props.no_arrive_status_meaning = 'Nema statusa dolaska';
_fc_props.no_begin_work_status_meaning = 'Status bez početka rada';
_fc_props.no_fully_mixed_status_meaning = 'Nema potpuno mješovitog statusa';
_fc_props.no_begin_work_or_at_job_status = 'Statusi "Početak rada" ili "Na poslu" nisu prisutni';
_fc_props.driver_didnt_follow_procedure = 'Vozač nije slijedio proceduru (nije usporio bubanj)';
_fc_props.probe_malfunction = 'Kvar sonde (unutrašnji kvar, itd.)';
_fc_props.no_data_from_probe = 'Nema podataka sa sonde (gubitak podataka)';
_fc_props.missing_probe_calibration = 'Nema podataka o kalibraciji sonde';
_fc_props.probe_pressure_not_in_range = 'Pritisak sonde nije u rasponu';
_fc_props.arrival = 'Dolazak';
_fc_props.small_load = 'MALO TERET';
_fc_props.dry_slump = 'SUŠNI PAD';
_fc_props.probe_remixing_turns = 'Remiksiranje';
_fc_props.turns_needed_to_remix = 'Dodana voda - Potrebno je dodatno miješanje';
_fc_props.probe_remixing_finished = 'Remiksiranje završeno';
_fc_props.probe_battery_low_alert = 'Upozorenje na slabu bateriju sonde';
_fc_props.probe_battery_low_message = 'Slaba baterija sonde';
_fc_props.probe_battery_low = 'Slaba baterija sonde';
_fc_props.alert_when_probe_battery_low = 'Upozorenje kada je baterija sonde slaba';
_fc_props.probe_sensor_fatal_failure = 'Fatalni kvar senzora';
_fc_props.probe_thermistor_failure = 'Kvar termistora';
_fc_props.probe_sensor_stuck_in_concrete = 'Senzor zaglavljen u betonu';
_fc_props.probe_sensor_over_weight = 'Senzor prekomjerne težine';
_fc_props.probe_batteries_low = 'Slaba baterija';
_fc_props.no_probe_data = 'Nema podataka sonde:';
_fc_props.check_probe = 'Provjerite sondu';
_fc_props.service_probe = 'Servisna sonda';
_fc_props.below_x = 'Ispod {0}';
_fc_props.above_x = 'Iznad {0}';
_fc_props.probe_serial_number_invalid_format = 'Serijski broj sonde nije u važećem formatu kao što je prikazano u rezerviranom mjestu za polje';
_fc_props.talk_dnd_permission_prompt = 'Za Talk je potrebna dozvola NE UZNEMIRAVAJ.';
_fc_props.max = 'Maks';
_fc_props.status_changed_quickly = 'Status se prebrzo promijenio';
_fc_props.is_empty = 'Prazno';
_fc_props.slump_increased_plasticizer_question = 'Je li dodat plastifikator?';
_fc_props.slump_increased_water_added_question = 'Koliko je nemjerene vode dodano?';
_fc_props.probe_and_drs_are_not_support_together_on_the_same_device = 'Praćenje sonde i ciklusa isporuke nisu podržani zajedno na istom uređaju.';
_fc_props.no_data_from_sensor = 'Nema podataka sa senzora (gubitak podataka)';
_fc_props.dvir = 'DVIR';
_fc_props.system_type = 'Tip sistema';
_fc_props.magnet_count = 'Broj magneta';
_fc_props.sensors_setup = 'Podešavanje senzora';
_fc_props.drs_requires_io_mac_sensor_drum_type_magnet_count = 'DCM zahtijeva podešavanje MAC adrese I/O kutije, tipa bubnja, tipa DCM-a i broja magneta.';
_fc_props.drs = 'DCM';
_fc_props.drs_ticketed_volume = 'Obim prijavljenih karata';
_fc_props.drs_current_volume = 'Trenutni volumen';
_fc_props.drs_current_water_cement_ratio = 'Trenutni odnos vode i cementa';
_fc_props.drs_target_water_cement_ratio = 'Ciljani odnos vode i cementa';
_fc_props.drs_total_revolutions = 'Ukupno';
_fc_props.drs_current_volume_lp_small = 'Trenutni';
_fc_props.drum_revolutions = 'Bubnjarske revolucije';
_fc_props.drs_total_revolutions_lp_small = 'Ukupno';
_fc_props.drs_charging_revolutions_lp_small = 'Punjenje';
_fc_props.drs_discharging_revolutions_lp_small = 'Pražnjenje';
_fc_props.drs_target_wc_lp_small = 'Target W/C';
_fc_props.drs_current_wc_lp_small = 'Trenutna voda/voda';
_fc_props.drs_ticketed_volume_lp_small = 'Plaćeno';
_fc_props.android_location_disclosure = 'TrackIt koristi preciznu i grubu lokaciju za prikupljanje podataka o lokaciji u pozadini čak i kada se ne koristi, kako bi omogućio automatsko određivanje statusa i vidljivost karte u stvarnom vremenu za otpremu.';
_fc_props.android_location_usage = 'Otkrivanje lokacije';
_fc_props.end_pour_trigger_threshold = 'Prag okidača za kraj sipanja';
_fc_props.drs_wiring_error = 'Greška u ožičenju';
_fc_props.drs_wiring_pulse_error = 'Greška impulsa ožičenja';
_fc_props.drs_wiring_magnet_error = 'Greška magneta za ožičenje';
_fc_props.drs_magnet_missing_error = 'Greška zbog nedostatka magneta';
_fc_props.android_location_disclosure_3p = 'TrackIt prikuplja podatke o lokaciji u pozadini kako bi omogućio automatsko određivanje statusa i vidljivost mape u stvarnom vremenu za otpremu. Kada pošiljatelj izvrši odjavu, lokacija se ne dijeli.';
_fc_props.please_select_either_fullmdm_or_trackit_remote_support = 'Molimo odaberite ili Puna MDM ili Trackit Daljinska podrška';
_fc_props.move_up = 'Pomakni gore';
_fc_props.move_down = 'Pomakni dolje';
_fc_props.driver_not_found = 'Vozač nije pronađen.';
_fc_props.multiple = 'Višestruko';
_fc_props.water_meter_installed = 'Vodomjer instaliran';
_fc_props.delete_waypoint = 'Izbriši tačku puta';
_fc_props.wash_sensor_installed = 'Senzor pranja instaliran';
_fc_props.washing_start_time = 'Vrijeme početka pranja';
_fc_props.end_washing = 'Završno pranje';
_fc_props.variable_rpms = 'Var RPM-ovi';
_fc_props.no_slump = 'Nema pada';
_fc_props.end_washing_duration = 'Kraj Trajanja Pranja';
_fc_props.privacy_policy = 'Politika privatnosti';
_fc_props.privacy_policy_text = 'Pročitao/la sam i prihvatam';
_fc_props.login_fail_accept_privacy_policy = 'Politika privatnosti mora biti prihvaćena da biste nastavili.';
_fc_props.rotation_sensor = 'Senzor rotacije';
_fc_props.pto_sensor = 'Senzor kardana';
_fc_props.pto_sensor_installed = 'Senzor PTO-a instaliran';
_fc_props.polarity_reversed = 'Obrnuti polaritet';
_fc_props.pto_sensor_type = 'Tip senzora PTO-a';
_fc_props.sensor_type = 'Tip senzora';
_fc_props.prompt_select_pto_sensor_type = 'Morate odabrati "Tip PTO senzora" ako ste odabrali "PTO senzor" kao glavni tip senzora.';
_fc_props.priming_turns_at_full_load = 'Prajmer se okreće pri punom opterećenju';
_fc_props.priming_turns_at_ten_percent_load = 'Usisavanje se okreće pri 10% opterećenja';
_fc_props.weight_units = 'Jedinice težine';
_fc_props.settings.send_status = 'Pošalji status/lokaciju na Event Bridge';
_fc_props.volume_difference = 'Razlika u volumenu';
_fc_props.mobile_ticket_iframe_url = 'URL iFrame-a za mobilne karte';
_fc_props.mobile_ticket_user = 'Korisnik mobilnih karata';
_fc_props.mobile_ticket_password = 'Lozinka za mobilnu kartu';
_fc_props.current_truck_status = 'Trenutni status kamiona';
_fc_props.estimated_symbol = '℮';
_fc_props.almost_equal_to_symbol = '≈';
_fc_props.triggered_by_max_revolutions = 'Pokreće se maksimalnim okretajima';
_fc_props.alerts_by_type = 'Obavještenja po vrsti';
_fc_props.water_flow_meter = 'Mjerač protoka vode';
_fc_props.flow_meter_no_pulses_warning = 'Nema pulseva - Upozorenje';
_fc_props.flow_meter_no_pulses_critical = 'Nema pulseva - Kritično';
_fc_props.flow_meter_excessive_pulses = 'Prekomjerni pulsevi';
_fc_props.flow_meter_constantly_flowing = 'Stalno teče';
_fc_props.flow_meter_good = 'Dobro';
_fc_props.whats_new = 'Šta je novo';
_fc_props.whats_new_widget_text = 'Da li ste znali da TrackIt ažuriramo barem jednom mjesečno? Primajte najnovija ažuriranja i savjete.';
_fc_props.get_the_scoop = 'Saznajte više';
_fc_props.trackit_insights = 'Trackit Insights';
_fc_props.business_analytics_blurb = 'Poslovna analitika koja poboljšava vaš profit, sada uključena u TrackIt';
_fc_props.find_out_more = 'Saznajte više';
_fc_props.daily_breakdown = 'Dnevni pregled';
_fc_props.question_summary = 'Sažetak pitanja';
_fc_props.trip_summary = 'Sažetak putovanja';
_fc_props.manage_employees = 'Upravljanje zaposlenicima';
_fc_props.manage_hotspots = 'Upravljanje žarišnim tačkama';
_fc_props.manage_devices = 'Upravljanje uređajima';
_fc_props.manage_equipment = 'Upravljanje opremom';
_fc_props.manage_users = 'Upravljanje korisnicima';
_fc_props.manage_statuses = 'Upravljanje statusima';
_fc_props.manage_alerts = 'Upravljanje upozorenjima';
_fc_props.popular_report_links = 'Popularni linkovi za izvještaje';
_fc_props.popular_settings_links = 'Popularne postavke';
_fc_props.sidemenu_settings = 'Postavke';
_fc_props.loads_per_driver = 'Teret po vozaču';
_fc_props.please_select_application = 'Molimo odaberite barem jednu aplikaciju';
_fc_props.external_app_processing = 'Obrada na eksternoj aplikaciji';
_fc_props.external_app_sent = 'Poslano u vanjsku aplikaciju';
_fc_props.external_app_received = 'Primila eksterna aplikacija';
_fc_props.wait_time_at_job = 'Vrijeme čekanja na poslu';
_fc_props.wait_time_at_plant = 'Vrijeme čekanja u pogonu';
_fc_props.loading_time = 'Vrijeme učitavanja';
_fc_props.unloading_time = 'Vrijeme istovara';
_fc_props.pre_post_trip = 'Prije/poslije putovanja';
_fc_props.update_thresholds = 'Ažuriraj pragove';
_fc_props.green = 'Zelena';
_fc_props.yellow = 'Žuta';
_fc_props.red = 'Crvena';
_fc_props.between = 'Između';
_fc_props.num_of_loads = 'Broj utovara';
_fc_props.num_of_drivers = '# vozača';
_fc_props.status_meaning_not_setup = 'Status Značenje nije postavljeno';
_fc_props.or_less = 'Ili manje';
_fc_props.or_greater = 'Ili Veće';
_fc_props.probe_self_diagnostic_state = 'Stanje samodijagnostike sonde';
_fc_props.update_current_truck_status_settings = 'Ažuriranje postavki trenutnog statusa kamiona';
_fc_props.default_behavior = 'Zadano (10 najvažnijih statusa)';
_fc_props.combine_similar_statuses = 'Kombiniraj iste statuse iz svih tipova (petlji)';
_fc_props.use_other_category = 'Koristite kategoriju \'Ostalo\'';
_fc_props.selected_statuses = 'Odabrani statusi';
_fc_props.ideas = 'Ideje';
_fc_props.air_content = 'Sadržaj zraka';
_fc_props.air_measured_time = 'Vrijeme mjereno u zraku';
_fc_props.ten_max = '10 Maks.';
_fc_props.loads_per_plant = 'Opterećenja po postrojenju';
_fc_props.invalid_flow_meter_pulse_per_volume = 'Nevažeći impuls mjerača protoka po volumenu.';
_fc_props.coming_soon_title = 'Uskoro više widgeta';
_fc_props.submit_your_ideas = 'Pošaljite svoje ideje našem Portalu ideja koristeći opciju "Sijalica" u navigacijskom meniju s lijeve strane.';
_fc_props.selected_plants = 'Odabrane biljke';
_fc_props.update_loads_per_plant_settings = 'Ažuriranje postavki opterećenja po postrojenju';
_fc_props.default_top_10_plants = 'Zadano (10 najboljih biljaka)';
_fc_props.phone_number_will_be_uploaded = 'ID uređaja će biti prenesen u svrhu registracije.';
_fc_props.include_deleted = 'Uključi izbrisano';
_fc_props.primary_status_type = 'Vrsta primarnog statusa';
_fc_props.additional_status_trigger = 'Dodatni okidači statusa';
_fc_props.update_tickets_destination = 'Ažuriraj odredište na svim povezanim kartama';
_fc_props.settings.send_destination_changes_to_connex = 'Pošalji promjene odredišta Connexu';
_fc_props.settings.is_the_ticket_active_when_it_is_received_by_trackit_default_always = 'Da li je karta aktivna kada je TrackIt primi (zadano \'uvijek\')';
_fc_props.settings.autoactivate_next_ticket_on_ticket_completion = 'Automatska aktivacija sljedećeg tiketa nakon završetka prethodnog tiketa';
_fc_props.settings.should_autoactivate_next_ticket_on_ticket_completion_default_true = 'Treba automatski aktivirati sljedeći tiket nakon kompletiranja tiketa (zadano \'true\')';
_fc_props.settings.status_to_idle_status_when_no_active_ticket = 'Status u status mirovanja kada nema aktivne karte';
_fc_props.break_down = 'Razbij';
_fc_props.idle = 'Neaktivan';
_fc_props.pto_work_maximum_speed_limit = 'Ograničenje maksimalne brzine na poslu';
_fc_props.settings.associate_ticket_to_status_on_complete = 'Promjena statusa saradnika koja kompletira tiket s tim tiketom';
_fc_props.approaching = 'Približava se';
_fc_props.performing_task = 'Izvršavanje zadatka';
_fc_props.are_you_sure_you_want_to_delete_geogate = 'Jeste li sigurni da želite izbrisati Geogate {0}?';
_fc_props.trackit_destination_changed_to_0 = 'Ažuriraj kartu {0}. Odredište je promijenjeno.';
_fc_props.trackit_return_destination_changed_to_0 = 'Ažuriraj kartu {0}. Povratak je promijenjen.';
_fc_props.menu_settings_title_geogate = 'Geografska vrata';
_fc_props.add_geogate = 'Dodajte geovrata';
_fc_props.driver_enabled = 'Vozač omogućen';
_fc_props.dispatcher_enabled = 'Dispečer omogućen';
_fc_props.runsheet_number = 'Broj radnog lista';
_fc_props.manual_load = 'Ručno punjenje';
_fc_props.delivery = 'Dostava';
_fc_props.return_run = 'Povratak trčanja';
_fc_props.home_run = 'Home Run';
_fc_props.edit_geogate = 'Uredi geogate';
_fc_props.handling = 'Rukovanje';
_fc_props.geogate_name = 'Geografska kapija';
_fc_props.geogate_panel = 'Geogratni panel';
_fc_props.vehicle_is_not_logged_in = 'Poruka nije poslana (vozilo nije prijavljeno)';
_fc_props.air = 'Zrak';
_fc_props.create_a_geogate = 'Napravite geokapiju';
_fc_props.click_the_map_to_set_the_geogate_points = 'Kliknite na mapu da biste postavili tačke geo-vrata.';
_fc_props.clock_out = 'Odjava';
_fc_props.handling_operation = 'Rukovanje operacijom';
_fc_props.view_geogates = 'Pogledajte geovrata';
_fc_props.select_a_geogate = 'Molimo odaberite geovrata';
_fc_props.failed_to_find_geogate = 'Nije pronađena Geogate';
_fc_props.adjust_geogate = 'Podesite geovrata';
_fc_props.geogate_expiration_date_time_extra_days = 'Datum isteka Geogate Vrijeme Zadano Dodatni dani';
_fc_props.menu_settings_title_retention = 'Zadržavanje podataka';
_fc_props.category = 'Kategorija';
_fc_props.telemetry = 'Telemetrija';
_fc_props.ticket_data = 'Podaci o ulaznicama';
_fc_props.driver_break = 'Pauza za vozača';
_fc_props._30_days = '30 dana';
_fc_props._6_months = '6 mjeseci';
_fc_props._1_year = '1 godina';
_fc_props._3_years = '3 godine';
_fc_props.discharge = 'Otpust';
_fc_props.new_group = 'Nova grupa';
_fc_props.selected_vehicles = 'Odabrana vozila';
_fc_props.group_name_is_required_field = 'Naziv grupe je obavezno polje';
_fc_props.at_least_vehicle_should_be_selected = 'Treba odabrati barem jedno vozilo';
_fc_props.groups = 'Grupe';
_fc_props.trucks = 'Kamioni';
_fc_props.geogate_has_been_removed_please_refresh_page = 'Geogate je uklonjen. Molimo osvježite stranicu.';
_fc_props.air_timestamp = 'Vremenska oznaka emitiranja';
_fc_props.fail = 'NEUSPJEH';
_fc_props.stuck = 'ZAGLAVLJEN';
_fc_props.dirty = 'PRLJAV';
_fc_props.driver_breakdown = 'Raspored';
_fc_props.seasonal = 'Sezonski';
_fc_props.category_details = 'Detalji kategorije';
_fc_props.alert_events = 'Događaji upozorenja';
_fc_props.driver_performance_infractions = 'Prekršaji u pogledu performansi vozača';
_fc_props.telemetry_details = 'Podaci o lokaciji, Vruće tačke, Vrijeme u vrućim tačkama, Vrijeme u regijama, DCM podaci, Podaci sonde, Podaci motora';
_fc_props.ticket_data_details = 'Podaci o ulaznicama';
_fc_props.general_details = 'Promjene statusa, Vremenske kartice, Rasporedi';
_fc_props.wash = 'Pranje';
_fc_props.filter_options = 'Opcije filtera';
_fc_props.home_plants = 'Kućne biljke';
_fc_props.delivery_multidrop = 'Višestruka dostava';
_fc_props.dcm = 'DCM';
_fc_props.pto_requires_pto_sensor_type_value = 'DCM PTO zahtijeva postavljanje tipa senzora PTO-a.';
_fc_props.invalid_io_box_mac_address = 'Nevažeća Mac adresa I/O kutije';
_fc_props.access_denied = 'Pristup odbijen';
_fc_props.wash_events = 'Događaji pranja';
_fc_props.min_speed = 'Minimalna brzina';
_fc_props.temperature_change = 'Promjena temperature';
_fc_props.degrees_cap = 'Stepeni';
_fc_props.washout_tracking = 'Praćenje ispiranja';
_fc_props.approaching_wash = 'Približava se Wash';
_fc_props.arrival_wash = 'Pranje dolaska';
_fc_props.performing_wash = 'Pranje';
_fc_props.wash_complete = 'Pranje završeno';
_fc_props.must_be_positive_or_zero = 'Mora biti pozitivno ili nula!';
_fc_props.min_speed_greater_than_max = 'Minimalna brzina mora biti manja od maksimalne brzine!';
_fc_props.clock_in = 'Prijave';
_fc_props.mix_water_at_x_to_y_for_t = 'Miješajte vodu pri brzini od {0} do {1} okretaja u minuti tokom {2} okretaja.';
_fc_props.discharge_water_for_x_revolutions = 'Ispustite vodu tokom {0} okretaja.';
_fc_props.eod_drum_wash_complete = 'Pranje bubnja završeno! <br> Zaustavite bubanj sa sondom na vrhu.';
_fc_props.washing_complete = 'Vođeno ispiranje završeno';
_fc_props.eod_washout_no_data_available = 'Podaci senzora nisu dostupni, molimo vas da završite proces pranja.';
_fc_props.eod_washout_no_data_available_title = 'Vođeno ispiranje nije dostupno';
_fc_props.menu_reports_title_ticket_time_summary = 'Sažetak vremena tiketa';
_fc_props.menu_reports_description_ticket_time_summary = 'Pregled informacija o vremenu izdavanja karte za narudžbu ili vozilo';
_fc_props.menu_reports_title_summary = 'Sažetak';
_fc_props.menu_reports_title_ticket_summary = 'Sažetak tiketa';
_fc_props.menu_reports_description_summary1 = 'Pogledajte sažetak vremena provedenog na vrućim tačkama';
_fc_props.menu_dispatch_title_main = 'Glavni';
_fc_props.menu_dispatch_title_login_registry = 'Prijava u registar';
_fc_props.menu_reports_title_main = 'Glavni';
_fc_props.time_management_are_you_sure_you_want_to_delete_export_data_type = 'Jeste li sigurni da želite izbrisati ovaj tip podataka za izvoz?';
_fc_props.dvir_status_paper_logs = 'Papirni dnevnici';
_fc_props.menu_reports_title_billing_report = 'Izvještaj o naplati';
_fc_props.menu_reports_description_billing_report = 'Izvještaj o naplati';
_fc_props.settings_status_to_ticketed_status_on_activate_work = 'Status prema statusu prijavljenog na Aktiviraj rad';
_fc_props.settings_status_to_ticketed_status_on_activate_work_default_false = 'Status prema statusu prijavljenog na Aktiviraj rad (zadano \'Netačno\')';
_fc_props.status_change_type_drum_rotation_sensor = 'DCM';
_fc_props.settings_connex_eid = 'Connex EID';
_fc_props.units_weight_pound_label = 'Funte';
_fc_props.units_weight_kilogram_label = 'Kilogrami';
_fc_props.settings_weight = 'Težina';
_fc_props.units_pounds = 'Funte';
_fc_props.units_kilograms = 'Kilogrami';
_fc_props.geo_gate_edit_modal_description = 'Opis';
_fc_props.geo_gate_edit_modal_start_point = 'Početna tačka';
_fc_props.geo_gate_edit_modal_end_point = 'Krajnja tačka';
_fc_props.geo_gate_edit_modal_vehicle_types = 'Vrsta opreme';
_fc_props.geo_gate_edit_modal_heading_south = 'Jug prema sjeveru';
_fc_props.geo_gate_edit_modal_heading_north = 'Sjever prema jugu';
_fc_props.geo_gate_edit_modal_driver_message = 'Poruka vozača';
_fc_props.geo_gate_edit_modal_dispatcher_message = 'Poruka o otpremi';
_fc_props.geo_gate_edit_modal_expiration_date_time = 'Datum isteka Vrijeme';
_fc_props.geo_gate_edit_modal_permanent = 'Trajno';
_fc_props.geo_gate_edit_modal_critical = 'Kritično';
_fc_props.geo_gate_edit_modal_error_message_description_empty = 'Greška prilikom spremanja Geogata: Polje Opis mora biti popunjeno.';
_fc_props.geo_gate_edit_modal_error_message_start_point_empty = 'Greška pri spremanju Geogata: Polje Početna tačka mora biti popunjeno.';
_fc_props.geo_gate_edit_modal_error_message_start_point_invalid_format = 'Greška pri spremanju Geogate-a: Polje Početna tačka sadrži nevažeći format podataka.';
_fc_props.geo_gate_edit_modal_error_message_end_point_invalid_format = 'Greška pri spremanju Geogate-a: Polje Krajnja tačka sadrži nevažeći format podataka.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_empty = 'Greška prilikom spremanja Geogate-a: Polje Datum isteka vremena mora biti popunjeno.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_invalid_format = 'Greška prilikom spremanja Geogate-a: Polje "Datum isteka" sadrži nevažeći format podataka.';
_fc_props.geo_gate_edit_modal_error_message_heading_north_dispatcher_message_empty = 'Greška u spremanju Geogate-a: Sjever prema jugu - polje za poruku otpreme mora biti popunjeno';
_fc_props.geo_gate_edit_modal_error_message_no_changes = 'Greška pri spremanju Geogate-a: Nisu otkrivene promjene';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_expired = 'Greška pri spremanju Geogate-a: Polje Datum isteka sadrži istekli datum i vrijeme';
_fc_props.geo_gate_edit_modal_error_message_description_invalid_format = 'Greška pri spremanju Geogate-a: Polje opisa mora sadržavati samo slova i brojeve';
_fc_props.geo_gate_edit_modal_error_message_vehicle_types_empty = 'Greška pri spremanju Geogate-a: Polje Tip opreme mora biti popunjeno';
_fc_props.geo_gate_table_message_label_north_to_south = 'Sjever prema jugu';
_fc_props.geo_gate_table_message_label_south_to_north = 'Jug prema sjeveru';
_fc_props.geo_gate_table_message_label_both = 'Oboje';
_fc_props.geo_gate_edit_modal_field_point_tip = 'Geografska širina, Geografska dužina';
_fc_props.geo_gate_edit_modal_device_movement_message_restriction = 'Označavanje ovog polja će poništiti podešavanje za ograničenje poruka o kretanju uređaja';
_fc_props.geo_gate_edit_modal_seasonal = 'Sezonski';
_fc_props.geo_gate_edit_modal_error_message_seasonal_empty = 'Greška pri spremanju Geogate-a: Sezonski datumi moraju biti popunjeni';
_fc_props.geo_gate_edit_modal_error_message_seasonal_invalid_date_format = 'Greška pri spremanju Geogate-a: Polja sezonskog datuma sadrže nevažeći format podataka';
_fc_props.test_js_test_javascript = 'Testni Javascript';
_fc_props.units_miles_per_hour_abbr = 'MPH';
_fc_props.units_kilometers_per_hour_abbr = 'KM/h';
_fc_props.units_kilometers = 'Kilometri';
_fc_props.units_miles = 'Milje';
_fc_props.units_gallons_abbr = 'GAL';
_fc_props.units_liters_abbr = 'L';
_fc_props.geo_gate_edit_modal_error_message_heading_south_driver_message_empty = 'Greška u spremanju Geogate-a: od juga do sjevera - polje za poruku vozača mora biti popunjeno';
_fc_props.geo_gate_edit_modal_error_message_heading_south_dispatcher_message_empty = 'Greška u spremanju Geogate-a: Od juga do sjevera - polje za poruku otpreme mora biti popunjeno';
_fc_props.geo_gate_edit_modal_error_message_heading_north_driver_message_empty = 'Greška u spremanju Geogate-a: Sjever prema jugu - polje Poruka vozača mora biti popunjeno';
_fc_props.geo_gate_heading = 'Naslov';
_fc_props.geo_gate_edit_modal_error_message_end_point_empty = 'Greška pri spremanju Geogate-a: Polje Krajnja tačka mora biti popunjeno';
_fc_props.units_mile = 'Milja';
_fc_props.units_kilometer = 'Kilometar';
_fc_props.cloud_dvir__exit = 'Izlaz';
_fc_props.cloud_dvir__signature = 'Potpis';
_fc_props.cloud_dvir__inspection = 'Inspekcija';
_fc_props.cloud_dvir__add_photos_notes = 'Dodaj fotografije/bilješke';
_fc_props.cloud_dvir__odometer_reading = 'Očitavanje kilometraže';
_fc_props.cloud_dvir__engine_hours = 'Sati rada motora';
_fc_props.cloud_dvir__truck_details = 'Detalji o kamionu';
_fc_props.cloud_dvir__determine_the_overall_condition_of_the_vehicle = 'Utvrdite opšte stanje vozila';
_fc_props.cloud_dvir__full_name_and_signature_of_driver = 'Puno ime i potpis vozača';
_fc_props.cloud_dvir__sign = 'Potpis';
_fc_props.cloud_dvir__driver_note_from = 'Napomena vozača od';
_fc_props.cloud_dvir__add_notes = 'Dodaj bilješke';
_fc_props.cloud_dvir__driver_notes = 'Napomene za vozača';
_fc_props.cloud_dvir__done = 'Gotovo';
_fc_props.cloud_dvir__needs_repair = 'Potrebna popravka';
_fc_props.cloud_dvir__not_applicable = 'Nije primjenjivo';
_fc_props.cloud_dvir__review_and_sign = 'Pregled i potpis';
_fc_props.cloud_dvir__add_photos = 'Dodaj fotografiju';
_fc_props.cloud_dvir__upload_photo_limit = 'Možete postaviti do 3 slike';
_fc_props.cloud_dvir__mismatch_title = 'Upozorenje na neusklađenost';
_fc_props.cloud_dvir__ok = 'U redu';
_fc_props.cloud_dvir_template = 'Predložak za DVIR u oblaku';
_fc_props.cloud_dvir__needs_review = 'DVIR treba pregledati';
_fc_props.cloud_dvir__submitted = 'Poslano';
_fc_props.cloud_dvir__completed_by = 'Završio/la';
_fc_props.cloud_dvir__review_btn = 'Recenzija';
_fc_props.cloud_dvir__truck_number = 'Kamion {0}';
_fc_props.cloud_dvir__pending_review = 'Čeka se pregled';
_fc_props.cloud_dvir__start_dvir = 'Pokreni DVIR';
_fc_props.cloud_dvir__dvir_history = 'Historija DVIR-a';
_fc_props.cloud_dvir__view_all = 'Prikaži sve';
_fc_props.load_zone = 'Zona opterećenja';
_fc_props.view_load_zones = 'Pogledajte zone opterećenja';
_fc_props.edit_load_zone = 'Uredi zonu opterećenja';
_fc_props.create_a_load_zone = 'Kreiraj zonu opterećenja';
_fc_props.load_zone_panel = 'Panel zone opterećenja';
_fc_props.click_the_map_to_set_the_load_zone_center = 'Kliknite na mapu da biste postavili centar zone opterećenja.';
_fc_props.cloud_dvir__mismatch_title_all_items_ok = 'Ovaj pregled je ukazao na nedostatke i odabrali ste da je ovo vozilo sigurno za upravljanje. Molimo vas da potvrdite prije nego što nastavite.';
_fc_props.cloud_dvir__mismatch_title_needs_repair = 'Ovaj pregled nije pokazao nikakve nedostatke i odabrali ste da je ovo vozilo nesigurno za upravljanje. Molimo vas da potvrdite prije nego što nastavite.';
_fc_props._90_days = '90 dana';
_fc_props.cloud_dvir = 'Oblak DVIR';
_fc_props.cloud_dvir_details = 'Podnesci u Cloud DVIR';
_fc_props.show_load_zones = 'prikaži zone opterećenja';
_fc_props.hide_load_zones = 'sakrij zone utovara';
_fc_props.no = 'Ne';
_fc_props.cloud_dvir__reset = 'Resetuj';
_fc_props.cloud_dvir__clear = 'Jasno';
_fc_props.mark_read = 'Mark Read';
_fc_props.mark_unread = 'Označi kao nepročitano';
_fc_props.read = 'Čitaj';
_fc_props.unread = 'Nepročitano';
_fc_props.air_sensor_serial_number = 'Serijski broj senzora zraka';
_fc_props.air_sensor_mac_address = 'MAC adresa senzora zraka';
_fc_props.air_sensor_serial_number_invalid_format = 'Serijski broj senzora zraka nije u važećem formatu: (alfanumerički i maksimalno 32 znaka s crticama)';
_fc_props.air_sensor_mac_address_invalid_format = 'MAC adresa senzora zraka nije u važećem heksadecimalnom formatu kao što je prikazano u rezerviranom mjestu za polje';
_fc_props.air_sensor_license = 'Senzor zraka';
_fc_props.adjust_route_point = 'Prilagodi tačku rute';
_fc_props.route_point_panel = 'Panel tačaka rute';
_fc_props.route_point = 'Tačka rute';
_fc_props.cloud_dvir__pre_trip = 'Prije putovanja';
_fc_props.cloud_dvir__post_trip = 'Nakon putovanja';
_fc_props.cloud_dvir__other_insction_type = 'Ostalo';
_fc_props.cloud_dvir__dvir_completed = 'Završeno';
_fc_props.cloud_dvir__awaiting_mechanic = 'Čekajući mehaničar';
_fc_props.cloud_dvir__awaiting_driver = 'Čekanje na potpis vozača';
_fc_props.unable_to_check_air_sensor_serial_number_please_contact_support_for_assistance = 'Nije moguće provjeriti serijski broj senzora zraka, kontaktirajte podršku za dodatnu pomoć.';
_fc_props.this_air_sensor_serial_number_exists_please_use_another_serial_number = 'Ovaj serijski broj senzora zraka već postoji, molimo koristite drugi serijski broj';
_fc_props.unable_to_check_air_sensor_mac_address_please_contact_support_for_assistance = 'Nije moguće provjeriti MAC adresu senzora zraka, obratite se podršci za pomoć';
_fc_props.cloud_dvir__error_submit_dvir_title = 'Greška pri slanju DVIR-a';
_fc_props.cloud_dvir__error_submit_dvir_descr = 'Molimo pokušajte ponovo';
_fc_props.ticket_integration_descr = 'Integracija tiketa omogućava podešavanje postavki integracije tiketa, kao i početnog ekrana / ekrana za učitavanje / ekrana za hard disk.';
_fc_props.cloud_dvir__success_submit_dvir_title = 'DVIR uspješno poslan';
_fc_props.cloud_dvir__inspection_trip_type = 'Vrsta inspekcijskog putovanja';
_fc_props.menu_dvir_title_mechanic = 'Mehaničar';
_fc_props.sidemenu_dvir = 'DVIR';
_fc_props.air_sensor_firmware = 'Firmver za senzor zraka';
_fc_props.when_no_active_ticket = 'Kada nema aktivne karte';
_fc_props.used_by = 'Koristio/la';
_fc_props.fields = 'Polja';
_fc_props.are_you_sure_you_want_to_delete_ticket_layout = 'Jeste li sigurni da želite izbrisati izgled tiketa "{0}"?';
_fc_props.menu_settings_title_ticket_layout = 'Raspored ulaznica';
_fc_props.add_ticket_layout = 'Dodaj izgled karte';
_fc_props.edit_ticket_layout = 'Uredi izgled karte';
_fc_props.ticket_layout_edit_modal_name = 'Ime';
_fc_props.ticket_layout_edit_modal_default = 'Zadano';
_fc_props.ticket_layout_edit_modal_error_message_name_empty = 'Greška prilikom spremanja izgleda tiketa: Polje za ime mora biti popunjeno.';
_fc_props.ticket_layout_edit_modal_error_message_name_invalid_format = 'Greška pri spremanju izgleda tiketa: Polje za ime mora sadržavati samo slova i brojeve';
_fc_props.ticket_layout_edit_modal_fields = 'Polja';
_fc_props.ticket_layout_edit_modal_usage = 'Upotreba';
_fc_props.ticket_layout_has_been_removed_please_refresh_page = 'Raspored tiketa je uklonjen. Molimo vas da osvježite stranicu.';
_fc_props.more_lower_case = 'više';
_fc_props.ticket_layout_edit_modal_error_selected_fields_are_empty = 'Greška prilikom spremanja izgleda tiketa: Morate odabrati jedno ili više polja.';
_fc_props.ticket_layout_edit_modal_error_selected_statuses_are_empty = 'Greška prilikom spremanja izgleda tiketa: Mora biti odabran jedan ili više statusa.';
_fc_props.cloud_dvir__ad_hoc = 'Ad hoc';
_fc_props.radius_multiplier_should_be = 'Množitelj radijusa treba biti broj s pomičnim oblikom';
_fc_props.ticket_max_activate_age_err = 'Maksimalni broj minuta za aktivaciju tiketa treba biti cijeli broj.';
_fc_props.max_hotspot_unused_days_errs = 'Maksimalan broj nekorištenih dana vruće tačke treba biti cijeli broj.';
_fc_props.begin_pour_air_content = 'Početak sipanja sadržaja zraka';
_fc_props.arrival_air_content = 'Sadržaj dolaznog zraka';
_fc_props.fully_mixed_air_content = 'Potpuno izmiješani sadržaj zraka';
_fc_props.departure_air_content = 'Sadržaj odlaznog aviona';
_fc_props.popup_enabled = 'Skočni prozor omogućen';
_fc_props.popup_disabled = 'Iskačući prozor onemogućen';
_fc_props.cloud_dvir__leave_confirmation_title = 'Upozorenje';
_fc_props.cloud_dvir__leave_confirmation_description = 'Ako sada napustite stranicu, sve promjene će biti izgubljene.';
_fc_props.cloud_dvir__leave_confirmation_approve = 'Potvrdi';
_fc_props.cloud_dvir__leave_confirmation_abort = 'Otkaži';
_fc_props.air_bt_ratio = 'Mjerenje senzora zraka';
_fc_props.cloud_dvir__view_photos_notes = 'Pogledajte fotografije/bilješke';
_fc_props.error_adding_the_status_it_will_create_a_blank_usage_in_another_ticket_layout = 'Dodavanje statusa će kreirati praznu upotrebu u drugom rasporedu tiketa. Želite li nastaviti s dodavanjem?';
_fc_props.vehicle_does_not_have_air_sensor_license = 'Vozilo nema dozvolu za senzor zraka.';
_fc_props.air_sensor_installed = 'Senzor zraka instaliran';
_fc_props.load_card = 'Učitaj karticu';
_fc_props.cloud_dvir__inspection_profile = 'Profil inspekcije';
_fc_props.cloud_dvir__view_details = 'Prikaži detalje';
_fc_props.cloud_dvir__certify_repairs = 'Ovjerite popravke';
_fc_props.cloud_dvir__repairs_made = 'Popravke izvršene';
_fc_props.cloud_dvir__repairs_not_necessary = 'Popravke nisu potrebne';
_fc_props.cloud_dvir__mechanic_note_from = 'Bilješka mehaničara od';
_fc_props.cloud_dvir__mechanic_assignment = 'Zadatak mehaničara';
_fc_props.cloud_dvir__mechanic_signature_description = 'Označite sve primjenjive stavke ispod i potpišite kako biste potvrdili da je vozilo pravilno pregledano.';
_fc_props.cloud_dvir__condition_satisfactory_label = 'Stanje ovog vozila je zadovoljavajuće';
_fc_props.cloud_dvir__defects_corrected_label = 'Nedostaci su ispravljeni';
_fc_props.cloud_dvir__repair_not_required_label = 'Popravka nije potrebna za siguran rad vozila';
_fc_props.safety = 'Sigurnost';
_fc_props.cloud_dvir__awaiting_sign = 'Čekanje znaka';
_fc_props.cloud_dvir__dvir_review = 'DVIR recenzija';
_fc_props.settings.mobile_auto_start_navigation = 'Automatsko pokretanje navigacije na mobilnom uređaju';
_fc_props.cloud_dvir__edit = 'Uredi';
_fc_props.delete_custom_label = 'Izbriši prilagođenu oznaku';
_fc_props.cloud_dvir__error_incompatible_aux_version = 'Vaša verzija TrackIt-a je zastarjela i neke DVIR funkcije možda neće ispravno raditi. Molimo vas da ažurirate TrackIt prije nego što nastavite.';
_fc_props.cloud_dvir__error_submit_dvir_signature = 'Došlo je do greške prilikom otpremanja potpisa. Pokušajte ponovo.';
_fc_props.max_hotspot_unused_days_error = 'Maksimalni broj nekorištenih dana vruće tačke ima maksimalno 1000 dana.';
_fc_props.menu_dvir_title_admin_templates = 'Predlošci';
_fc_props.menu.dvir = {};
_fc_props.menu.dvir.admin = {};
_fc_props.menu.dvir.admin.title = 'Administrator';
_fc_props.cloud_dvir__admin_templates = 'Predlošci';
_fc_props.form_name = 'Naziv obrasca';
_fc_props.form_status = 'Status obrasca';
_fc_props.menu.dvir.title = 'DVIR';
_fc_props.cloud_dvir__option_download = 'Preuzmi';
_fc_props.cloud_dvir__option_view = 'Prikaz';
_fc_props.cloud_dvir__inspectortype_driver = 'Vozač';
_fc_props.menu.dvir.description = {};
_fc_props.menu.dvir.description.admin = 'Pregled/Uređivanje/Kreiranje prilagođenih DVIR obrazaca i podnesaka';
_fc_props.menu.dvir.description.mechanic = 'Pregled/Uređivanje podnesenih zahtjeva za djelovanje u DVIR-u';
_fc_props.not_in_use = 'Nije u upotrebi';
_fc_props.logged_in = 'prijavljen/a';
_fc_props.reviewing_driver = 'Pregled vozača';
_fc_props.cloud_dvir__report_title = 'Izvještaj o pregledu vozila vozača';
_fc_props.cloud_dvir__report_signed = 'potpisan';
_fc_props.cloud_dvir__report_page_counter = 'Stranica {0} od {1}';
_fc_props.cloud_dvir__report_defects = 'Nedostaci';
_fc_props.cloud_dvir__report_comments = 'Komentari';
_fc_props.cloud_dvir__report_inspection_table_title = 'Pregled vozila';
_fc_props.cloud_dvir__report_driver_table_title = 'Informacije o vozaču';
_fc_props.cloud_dvir__report_carrier = 'Nosilac';
_fc_props.cloud_dvir__report_truck = 'Kamion';
_fc_props.cloud_dvir__report_location = 'Lokacija';
_fc_props.cloud_dvir__report_odometer = 'Brojač kilometara';
_fc_props.cloud_dvir__report_hours = 'Sati';
_fc_props.cloud_dvir__report_no_comments = 'Nema komentara';
_fc_props.include_unlicensed_vehicles = 'Uključi neregistrirana vozila';
_fc_props.cloud_dvir__search_by_form_name = 'Pretraži po nazivu obrasca';
_fc_props.cloud_dvir__create_dvir = 'Kreirajte DVIR';
_fc_props.cloud_dvir__update_dvir = 'Ažuriranje DVIR-a';
_fc_props.cloud_dvir__form_name = 'Naziv obrasca';
_fc_props.cloud_dvir__form_description = 'Opis obrasca';
_fc_props.cloud_dvir__form_status = 'Status obrasca';
_fc_props.information = 'Informacije';
_fc_props.cloud_dvir__search_categories = 'Kategorije pretraživanja';
_fc_props.cloud_dvir__create_new_category = 'Kreiraj novu kategoriju';
_fc_props.category_name = 'Naziv kategorije';
_fc_props.sub_category = 'Podkategorija';
_fc_props.sub_category_name = 'Naziv podkategorije';
_fc_props.delete_category = 'Izbriši kategoriju';
_fc_props.cloud_dvir__dvir_information = 'Informacije o DVIR-u';
_fc_props.cloud_dvir__dvir_choose_categories = 'Odaberite kategorije';
_fc_props.cloud_dvir__create_category = 'Kreiraj kategoriju';
_fc_props.cloud_dvir__update_category = 'Ažuriraj kategoriju';
_fc_props.delete_route_point = 'Izbriši tačku rute';
_fc_props.view_route_points = 'Pogledajte tačke rute';
_fc_props.ignore_cancel_preload = 'Ignorišite otkazivanje, unaprijed ste učitani. Vaš home run će uskoro biti prikazan.';
_fc_props.cloud_dvir__assigned_mechanic = 'Dodijeljeni mehaničar';
_fc_props.cloud_dvir__add_mechanic = 'Dodajte mehaničara';
_fc_props.contact_type = 'Vrsta kontakta';
_fc_props.cloud_dvir__send_email_notifications = 'Pošalji obavještenja putem e-pošte';
_fc_props.menu_dvir_title_admin_dvir = 'DVIR';
_fc_props.cloud_dvir__error_retrieving_dvir_history = 'Greška prilikom preuzimanja zapisa historije DVIR-a.';
_fc_props.cloud_dvir__error_processing_dvir_record = 'Greška prilikom preuzimanja DVIR zapisa.';
_fc_props.cloud_dvir__error_saving_submission = 'Greška prilikom spremanja prijave. Pokušajte ponovo.';
_fc_props.cloud_dvir__error_retrieving_mechanics = 'Greška prilikom preuzimanja liste mehaničara.';
_fc_props.cloud_dvir__template_saved = 'Šablon sačuvan';
_fc_props.cloud_dvir__error_retrieving_dvir_templates = 'Greška prilikom preuzimanja liste predložaka.';
_fc_props.cloud_dvir__error_saving_dvir_template = 'Greška prilikom spremanja predloška. Pokušajte ponovo.';
_fc_props.dispatch_group = 'Grupa za otpremu';
_fc_props.save_adjust = 'Sačuvaj i prilagodi tačku rute';
_fc_props.reset_route_point = 'Resetuj tačku rute';
_fc_props.no_records_stub_adjust_filters = 'Pokušajte prilagoditi postavke pretrage ili filtera kako biste povećali broj rezultata.';
_fc_props.no_dvir_records = 'Svi su upoznati sa DVIR-ima!';
_fc_props.no_dvir_records_sub_title = 'Mnogo si postigao/la';
_fc_props.settings.master_data_connex_x_api_key = 'Master Data Connex x-api-key';
_fc_props.slump_not_obtained_for_x = 'Nije dobijeno očitanje slijeganja za: {0}';
_fc_props.please_select_a_sensor_status_type = 'Molimo odaberite tipove statusa senzora kako biste pokrenuli ovo upozorenje';
_fc_props.settings.master_data_connex_token = 'Glavni podaci Connex token';
_fc_props.error_validating_master_data_connex_credentials = 'Greška prilikom validacije Master Data Connex vjerodajnica';
_fc_props.settings.master_data_connex_base_url = 'URL baze glavnih podataka Connex';
_fc_props.settings.master_data_connex_exp_time = 'Vrijeme isteka glavnih podataka Connex';
_fc_props.download_template = 'Preuzmi predložak';
_fc_props.menu_settings_title_dispatch_group = 'Grupe za otpremu';
_fc_props.settings.dispatch_groups = 'Grupe za otpremu';
_fc_props.dispatch_group_name = 'Naziv grupe za otpremu';
_fc_props.dispatch_group_plants = 'Postrojenja grupe za otpremu';
_fc_props.dispatch_group_plants_mapping_message = 'Navedite koje će biljke biti dio ove Dispečerske grupe.';
_fc_props.dispatch_group_users_mapping_message = 'Navedite koji će korisnici biti dio ove Dispečerske grupe.';
_fc_props.dispatch_group_plant_disassociation_message = 'Postrojenje treba biti pod upravom jedne dispečerske grupe u datom trenutku.';
_fc_props.dispatch_group_search_by_plant = 'Pretraživanje po nazivu biljke';
_fc_props.dispatch_group_search_by_username = 'Pretraži po korisničkom imenu';
_fc_props.search_by_dispatch_group_name = 'Pretraživanje po nazivu grupe za otpremu';
_fc_props.create_dispatch_group = 'Kreirajte grupu za otpremu';
_fc_props.update_dispatch_group = 'Ažuriranje grupe za otpremu';
_fc_props.dispatch_group_saved = 'Grupa za otpremu sačuvana';
_fc_props.warning_deleting_dispatch_group_unassociate_plants = 'Brisanjem ove dispečerske grupe kreirat će se zadane dispečerske grupe za povezane elektrane.';
_fc_props.error_saving_dispatch_group = 'Greška prilikom spremanja grupe za otpremu. Pokušajte ponovo.';
_fc_props.please_enter_a_valid_plant_num = 'Molimo unesite važeći broj postrojenja.';
_fc_props.cloud_dvir__report_no_defects = 'Nema nedostataka';
_fc_props.shoud_select_dispatch_group = 'Morate odabrati barem jednu grupu za otpremu';
_fc_props.one_or_more_users_are_associated_with_this_dispatch_group_only = 'Nije moguće izbrisati jer ova Dispečerska grupa sadrži korisnike koji su povezani samo s ovom Dispečerskom grupom.';
_fc_props.cloud_dvir__username = 'Korisničko ime';
_fc_props.cloud_dvir__password = 'Lozinka';
_fc_props.cloud_dvir__login = 'Prijava';
_fc_props.cloud_dvir__mechanic_sign_in = 'Prijava mehaničara';
_fc_props.delete_dispatch_group = 'Izbriši grupu za otpremu';
_fc_props.cloud_dvir__driver = 'Vozač';
_fc_props.cloud_dvir__equipment_pound = 'Oprema #';
_fc_props.cloud_dvir__mechanic = 'Mehaničar';
_fc_props.dispatch_group_user_only_unassociate_message = 'Nije moguće izbrisati korisnika jer korisnici moraju biti povezani s barem jednom Dispatch grupom.';
_fc_props.cloud_dvir__time_period_filter_today = 'Danas';
_fc_props.cloud_dvir__time_period_filter_yesterday = 'Jučer';
_fc_props.cloud_dvir__time_period_filter_last_7_days = 'Posljednjih 7 dana';
_fc_props.cloud_dvir__time_period_filter_last_30_days = 'Posljednjih 30 dana';
_fc_props.cloud_dvir__date_range_filter = 'Filtriraj po datumu';
_fc_props.cloud_dvir__download = 'Preuzmi';
_fc_props.dispatch_group_is_empty = 'Grupa za otpremu ne može biti prazna.';
_fc_props.dispatch_group_with_empty_plants = 'Najmanje jedna elektrana mora biti povezana s dispečerskom grupom.';
_fc_props.dispatch_group_with_empty_users = 'Najmanje jedan korisnik mora biti povezan s grupom za otpremu.';
_fc_props.not_delete_one_or_more_users_are_associated_with_this_dispatch_group_only = 'Nije moguće izbrisati Dispečersku grupu jer sadrži korisnike koji su povezani samo s ovom Dispečerskom grupom.';
_fc_props.dispatch_group_not_exists = 'Grupa za otpremu ne postoji.';
_fc_props.dispatch_group_contains_one_plant = 'Nije moguće izbrisati jer ova Grupa za otpremu sadrži samo jednu biljku.';
_fc_props.dispatch_group_users = 'Korisnici grupe za otpremu';
_fc_props.cloud_dvir__error_retrieving_dvir = 'Greška prilikom preuzimanja DVIR zapisa';
_fc_props.cloud_dvir__assign_mechanic = 'Dodijeli mehaničara';
_fc_props.cloud_dvir__submit_review = 'Pošalji recenziju';
_fc_props.error_deleting_dispatch_group = 'Greška prilikom brisanja grupe za otpremu.';
_fc_props.error_retrieving_dispatch_groups = 'Greška prilikom preuzimanja liste grupa za otpremu.';
_fc_props.cloud_dvir__undo_selection = 'Poništi odabir';
_fc_props.enable_master_data = 'Omogući glavne podatke';
_fc_props.manually_sync = 'Ručna sinhronizacija';
_fc_props.master_data_connex_token_expiration = 'Istek tokena Master Data Connex';
_fc_props.cloud_dvir__time_period_filter_custom = 'Prilagođeno';
_fc_props.settings.zello_session_timeout_minutes = 'Vremensko ograničenje Zello sesije (minute)';
_fc_props.menu_settings_title_master_data = 'Glavni podaci';
_fc_props.settings.master_data = 'Glavni podaci';
_fc_props.error_retrieving_master_data = 'Greška pri preuzimanju glavnih podataka';
_fc_props.master_data_sync_completed = 'Sinhronizacija glavnih podataka završena';
_fc_props.master_data_successfully_updated = 'Podaci su uspješno ažurirani';
_fc_props.master_data_failed_to_update = 'Spremanje nije uspjelo.';
_fc_props.master_data_sync_initiated = 'Sinhronizacija glavnih podataka pokrenuta';
_fc_props.master_data_sync_failed = 'Sinhronizacija glavnih podataka nije uspjela';
_fc_props.enabled_excluding_origin_on_deliveries = 'Tačno (isključujući porijeklo na otpremnicama)';
_fc_props.enabled_including_origin_on_deliveries = 'Tačno (uključujući porijeklo na otpremnicama)';
_fc_props.cloud_dvir__i_will_decide_later = 'Odlučiću kasnije';
_fc_props.returning = 'Povratak';
_fc_props.leftover_concrete = 'Ostaci betona';
_fc_props.leftover_concrete_on_vehicle_x = 'Ostaci betona na vozilu {0}';
_fc_props.leftover_concrete_alert = 'Upozorenje na ostatke betona';
_fc_props.wc_ratio_exceeded = 'Prekoračen odnos vode i ugljika';
_fc_props.search_by_site_name = 'Pretraži po nazivu web-lokacije';
_fc_props.sites = 'Stranice';
_fc_props.token_expiration = 'Istek tokena';
_fc_props.menu_settings_title_connex_api_key_management = 'Upravljanje ključevima Connex API-ja';
_fc_props.settings.connex_api_key_management = 'Upravljanje ključevima Connex API-ja';
_fc_props.error_retrieving_connex_api_key_data = 'Greška pri preuzimanju podataka ključa connex API-ja';
_fc_props.qr_code = 'QR kod';
_fc_props.informing_driver_and_interface_when_entering_wrong_plant = 'Obavještavanje vozača i interfejsa prilikom ulaska u pogrešan pogon';
_fc_props.enable_driver_message = 'Omogući poruku vozaču';
_fc_props.enable_dispatch_message = 'Omogući poruku o otpremi';
_fc_props.enable_sending_message_to_interface = 'Omogući slanje poruke na interfejs';
_fc_props.ticket_qr_code = 'QR kod';
_fc_props.leftover_concrete_alert_description = 'Upozorenje kada se pronađu ostaci betona nakon izlivanja.';
_fc_props.minimum_leftover_concrete_amount = 'Minimalna količina preostalog betona';
_fc_props.error_validating_master_data_connex_credentials_unauthorized = 'Greška prilikom validacije glavnih podataka Connex vjerodajnica nije autorizirano';
_fc_props.error_validating_master_data_connex_credentials_permissions = 'Greška prilikom validacije dozvola za Master Data Connex vjerodajnice';
_fc_props.error_validating_master_data_connex_url_not_found = 'Greška prilikom validacije URL-a glavnog podatka. Nije pronađen.';
_fc_props.error_validating_master_data_connex_unknown_error = 'Greška prilikom validacije glavnih podataka Connex Nepoznata greška';
_fc_props.master_data_sync_failed_sync_up_vehicle_type = 'Sinhronizacija glavnih podataka nije uspjela. Sinhronizacija tipa vozila.';
_fc_props.master_data_sync_failed_sync_up_vehicle = 'Sinhronizacija glavnih podataka nije uspjela. Sinhronizujte vozilo.';
_fc_props.master_data_sync_failed_sync_up_plant = 'Sinhronizacija glavnih podataka nije uspjela. Sinhronizacija postrojenja.';
_fc_props.master_data_sync_failed_data_base_connection = 'Sinhronizacija glavnih podataka nije uspjela prilikom povezivanja s bazom podataka.';
_fc_props.error_validating_master_data_connex_permission_is_insufficient = 'Greška prilikom validacije Master Data Connex vjerodajnica. Dozvola za token nosioca nije dovoljna.';
_fc_props.settings.back_date_arrive_job = 'Posao s datumom dolaska unazad';
_fc_props.device_notifications = 'Obavještenja';
_fc_props.loading_number = 'Broj za učitavanje';
_fc_props.leftover_concrete_volume_temp_age = 'Preostala zapremina={0}, Temperatura={1}, Starost={2}';
_fc_props.total_ordered = 'Ukupna naručena količina';
_fc_props.total_ticketed = 'Dostavljeno Naručeno';
_fc_props.load_number = 'Broj učitavanja';
_fc_props.min_leftover_concrete_must_be_filled_in_and_gt_x = 'Minimalni preostali beton mora biti popunjen i veći od {0}';
_fc_props.error_validating_master_data_connex_credentials_are_the_same = 'Greška prilikom validacije glavnih podataka. Vjerodajnice ne mogu biti iste.';
_fc_props.use_aws_for_talk = 'Koristite AWS za razgovor';
_fc_props.air_readings_not_supported = 'Očitavanja zraka nisu podržana';
_fc_props.air_not_supported = 'Zrak nije podržan';
_fc_props.mix_not_supported = 'Miks nije podržan';
_fc_props.air_default_and_none_not_supported = 'Ne možete istovremeno odabrati zadano i nije podržano!';
_fc_props.notifications_enabled = 'Obavještenja omogućena';
_fc_props.prevent_status_change = 'Spriječite promjenu statusa';
_fc_props.message_to_interface = 'Poruka interfejsu';
_fc_props.prevent_wrong_plant = 'Spriječite pogrešnu biljku';
_fc_props.previous_tickets = 'Prethodne ulaznice';
_fc_props.audit_ticket_number = 'Broj karte';
_fc_props.audit_date_created = 'Datum kreiranja';
_fc_props.audit_vehicle_number = 'Broj vozila';
_fc_props.cloud_dvir__table_ok = 'Sigurno za upotrebu';
_fc_props.cloud_dvir__table_needs_repair = 'Nije sigurno za upotrebu';
_fc_props.missing_air_calibration = 'Nema podataka o kalibraciji zraka';
_fc_props.reported_defects = 'Prijavljeni nedostaci';
_fc_props.address_latitude = 'Geografska širina adrese';
_fc_props.address_longitude = 'Geografska dužina adrese';
_fc_props.routing_latitude = 'Geografska širina rute';
_fc_props.routing_longitude = 'Geografska dužina rute';
_fc_props.category_name_must_be_unique = 'Naziv kategorije mora biti jedinstven';
_fc_props.subcategory_name_must_be_unique = 'Naziv podkategorije mora biti jedinstven';
_fc_props.menu_settings_tracking_device = 'Uređaj za praćenje';
_fc_props.menu_settings_title_tracking_device = 'Uređaj za praćenje';
_fc_props.menu_settings_title_personal_device_registration = 'Registracija ličnog uređaja';
_fc_props.registration_code = 'Registracijski kod';
_fc_props.creation_date = 'Stvaranje';
_fc_props.expiration_date = 'Istek';
_fc_props.trackitadmin_personal_device_registration = 'Registracija ličnog uređaja';
_fc_props.create_registration_code = 'Dodajte registracijski kod';
_fc_props.remove_registration_code = 'Ukloni registracijski kod';
_fc_props.add_a_registration_code = 'Dodajte registracijski kod';
_fc_props.select_number_of_registration_codes_to_generate = 'Odaberite broj registracijskih kodova koje želite generirati.';
_fc_props.registration_code_count = 'Broj registracijskih kodova';
_fc_props.are_you_sure_you_want_to_delete_this_reg_code = 'Jeste li sigurni da želite izbrisati odabrani registrovani kod?';
_fc_props.are_you_sure_you_want_to_delete_selected_reg_codes = 'Jeste li sigurni da želite izbrisati odabrane registrovane kodove?';
_fc_props.add_personal_device = 'Dodaj lični uređaj';
_fc_props.menu_settings_title_personal_device = 'Lični uređaj';
_fc_props.cloud_dvir__approval_critical_alert = 'Vozilo ima kritičan kvar. Ne može se označiti kao sigurno za upotrebu.';
_fc_props.export_registration_codes = 'Izvozni registracijski kodovi';
_fc_props.download_format = 'Preuzmi format';
_fc_props.specify_download_format_x = 'Navedite format preuzimanja za izvoz {0} registracijskih kodova';
_fc_props.personal_device_download = 'Preuzmi';
_fc_props.add_personal_device_input_message = 'Unesite lični ID uređaja ispod. Istek će se automatski primijeniti nakon spremanja.';
_fc_props.error_creating_personal_device = 'Greška prilikom kreiranja ličnog uređaja';
_fc_props.device_already_exists = 'Lični uređaj već postoji';
_fc_props.export = 'Izvoz';
_fc_props.error_can_not_change_connex_eid = 'Ne mogu promijeniti connex eid jer se trenutno koristi za glavne podatke';
_fc_props.remove_personal_device = 'Uklonite lični uređaj';
_fc_props.are_you_sure_you_want_to_delete_this_personal_device = 'Jeste li sigurni da želite izbrisati odabrani lični uređaj?';
_fc_props.are_you_sure_you_want_to_delete_selected_personal_devices = 'Jeste li sigurni da želite izbrisati odabrane lične uređaje?';
_fc_props.error_deleting_personal_device = 'Greška pri brisanju ličnog uređaja';
_fc_props.customerid = 'ID kupca';
_fc_props.customername = 'Ime kupca';
_fc_props.ordernumber = 'Broj narudžbe';
_fc_props.orderdescription = 'Opis narudžbe';
_fc_props.locationid = 'ID lokacije';
_fc_props.locationdescription = 'Opis lokacije';
_fc_props.productid = 'ID proizvoda';
_fc_props.productdescription = 'Opis proizvoda';
_fc_props.vehicleid = 'ID vozila';
_fc_props.vehicledescription = 'Opis vozila';
_fc_props.ticketnumber = 'Broj karte';
_fc_props.ticketdate = 'Datum/vrijeme karte';
_fc_props.drivername = 'Ime vozača';
_fc_props.arriveregion = 'Regija dolaska (VRIJEME)';
_fc_props.leaveregion = 'Napusti regiju (TIME)';
_fc_props.regionduration = 'Trajanje regije';
_fc_props.menu_reports_title_prevailing_wage = 'Prevladavajuća nadnica';
_fc_props.slump_calibration_x_not_found_for_y = 'Kalibracija slijeganja "{0}" nije pronađena za tiket {1}';
_fc_props.slump_calibration_not_found = 'Kalibracija slijeganja nije pronađena';
_fc_props.slump_calibration_not_found_description = 'Upozorenje kada kalibracija slijeganja nije pronađena';
_fc_props.error_getting_personal_device_list = 'Greška pri preuzimanju liste ličnih uređaja';
_fc_props.batch_summary_date_range_note = '*NAPOMENA: Ovaj izvještaj je ograničen na 3 dana ako se ne primjenjuju filteri. Raspon datuma može ići do 31 dan kada se filtrira po opremi (maksimalno 10), postrojenju (maksimalno 1), proizvodu (maksimalno 1) ili poslu (maksimalno 1)';
_fc_props.select_registration_code_expiration_time_days = 'Odaberite broj dana do isteka registracijskih kodova, a zatim kliknite Spremi.';
_fc_props.add_personal_device_expiration = 'Istek (u danima)';
_fc_props.cloud_dvir__vehicle_no = 'Broj vozila';
_fc_props.cloud_dvir__trailer_no = 'Broj prikolice';
_fc_props.cloud_dvir__vehicle = 'Vozilo';
_fc_props.cloud_dvir__trailer = 'Prikolica';
_fc_props.cloud_dvir__truck_number_label = 'Broj kamiona';
_fc_props.cloud_dvir__trailer_number = 'Broj prikolice';
_fc_props.cloud_dvir__has_trailer = 'Ne vozim s prikolicom';
_fc_props.cloud_dvir__trailer_input_field_prompt = 'Ovdje unesite broj svoje prikolice';
_fc_props.work_order = 'Radni nalog';
_fc_props.unable_to_determine_slump = 'Nije moguće utvrditi pad';
_fc_props.cloud_dvir__determine_the_overall_condition_of_the_trailer = 'Utvrdite opće stanje prikolice';
_fc_props.defaultTrailer = 'Zadani trejler';
_fc_props.trailer_type_column_billable = 'Naplativo';
_fc_props.trailer_type_column_notes = 'Bilješke';
_fc_props.trailer_type_column_date = 'Datum';
_fc_props.trailer_type_column_order = 'Narudžba';
_fc_props.trailer_type_column_ticket = 'Karta';
_fc_props.trailer_type_column_project = 'Projekt';
_fc_props.trailer_type_column_customer = 'Kupac';
_fc_props.trailer_type_column_location = 'Lokacija';
_fc_props.trailer_type_column_vehicle_type = 'Tip vozila';
_fc_props.trailer_type_column_product = 'Proizvod';
_fc_props.trailer_type_action_rebill = 'Ponovna naplata';
_fc_props.master_data_sync_failed_no_default_vehicle_type_has_been_set = 'Sinhronizacija glavnih podataka nije uspjela, nije postavljen zadani tip opreme.';
_fc_props.trailer_type = 'Tip prikolice';
_fc_props.trailer_type_is_required = 'Vrsta prikolice je obavezna';
_fc_props.trailer_number_already_exists = 'Broj prikolice već postoji';
_fc_props.plate_number_already_exists = 'Registarski broj već postoji';
_fc_props.trailer_vin_already_exists = 'Vin prikolice već postoji';
_fc_props.trailer_does_not_exist = 'Najava ne postoji';
_fc_props.trailer_number_is_required = 'Broj prikolice je obavezan';
_fc_props.plate_number_is_required = 'Broj registarske tablice je obavezan';
_fc_props.plate_number = 'Broj registarske tablice';
_fc_props.menu_settings_title_trailer = 'Prikolica';
_fc_props.add_trailer = 'Dodaj trejler';
_fc_props.edit_trailer = 'Uredi najavu';
_fc_props.menu_settings_title_equipment = 'Oprema';
_fc_props.settings_ignore_new_tickets_from_command_cloud_older_than_specified_minutes = 'Ignorišite nove tikete od Command Clouda starije od X minuta';
_fc_props.settings_ignore_new_tickets_from_command_cloud_older_than_specified_minutes_title = 'Zanemari nove tikete iz Command Clouda sa datumom i vremenom otpreme starijim od X minuta (zadano je prazno i isključeno)';
_fc_props.edit_load_card = 'Uredi karticu za učitavanje';
_fc_props.default_layout = 'Zadani raspored';
_fc_props.load_card_empty_fields = 'Greška prilikom spremanja kartice za učitavanje: Morate odabrati jedno ili više polja.';
_fc_props.trailers = 'Prikolice';
_fc_props.error_failed_to_save_data = 'Greška: Spremanje podataka nije uspjelo';
_fc_props.slump_increased_plasticizer_added_question = 'Koliko je plastifikatora dodano?';
_fc_props.add_trailer_type = 'Dodaj tip prikolice';
_fc_props.menu_settings_title_trailer_type = 'Tip prikolice';
_fc_props.edit_trailer_type = 'Uredi vrstu najave';
_fc_props.single_use_codes = 'Kodovi za jednokratnu upotrebu';
_fc_props.multiple_use_codes = 'Kodovi za višestruku upotrebu';
_fc_props.trailer_type_description_is_required = 'Opis tipa prikolice je obavezan';
_fc_props.trailer_saved = 'Najava sačuvana';
_fc_props.cloud_dvir__trailer_only_dvir = 'Samo trejler DVIR';
_fc_props.choose_file = 'Odaberite datoteku';
_fc_props.no_file_chosen = 'Nije odabrana nijedna datoteka';
_fc_props.please_choose_file = 'Molimo odaberite datoteku';
_fc_props.no_filters = 'Nije odabran nijedan filter';
_fc_props.remaining_defects = 'Preostali nedostaci';
_fc_props.load_more = 'Učitaj još';
_fc_props.pagination_label = '{0}-{1} od {2}';
_fc_props.extend = 'Produži';
_fc_props.cloud_dvir__notes_or_photo_required = 'Potrebne su ili bilješke ili fotografija.';
_fc_props.no_default_plant_specified_failed_to_save = 'Nije navedena zadana postrojenja.';
_fc_props.no_default_employee_type_specified_failed_to_save = 'Nije navedena zadana vrsta zaposlenika.';
_fc_props.personal_device_registration_code_saved = 'Sačuvan je kod za registraciju ličnog uređaja';
_fc_props.error_saving_personal_device_registration_code = 'Greška prilikom spremanja koda za registraciju ličnog uređaja. Pokušajte ponovo.';
_fc_props.settings.master_data_sub_title = 'Postavite integraciju glavnih podataka između TrackIt-a i Connex-a';
_fc_props.connex_authentication = '{0} Autentifikacija';
_fc_props.select_company = 'Odaberite kompaniju';
_fc_props.requirements = 'Zahtjevi';
_fc_props.default_plant_type = 'Zadana biljka';
_fc_props.default_employee_type = 'Zadani tip zaposlenika';
_fc_props.default_equipment_type = 'Zadani tip opreme';
_fc_props.support_alphanumeric_trucks = 'Podrška za alfanumeričke kamione';
_fc_props.no_default_equipment_type_specified_failed_to_save = 'Nije navedena zadana vrsta opreme.';
_fc_props.air_pau_battery_low_message = 'Upozorenje na praznu bateriju Air PAU-a';
_fc_props.air_pau_battery_low = 'Prazna baterija Air PAU-a';
_fc_props.alert_when_air_pau_battery_low = 'Upozorenje kada je baterija Air PAU-a slaba';
_fc_props.air_pau_battery_low_alert = 'Upozorenje na nizak nivo baterije u zraku';
_fc_props.sensor_unable_to_determine_slump = 'Senzor ne može odrediti slijeganje';
_fc_props.menu_settings_title_export = 'Izvoz';
_fc_props.compare_company = 'Uporedite s drugom kompanijom';
_fc_props.site_settings = 'Postavke web-lokacije';
_fc_props.permission_type = 'Vrsta dozvole';
_fc_props.ticket_integration = 'Integracija tiketa';
_fc_props.select_one_or_more_settings = 'Molimo odaberite jednu ili više postavki';
_fc_props.export_tooltip = 'Ova opcija je dostupna samo ako pripadate više od jedne kompanije.';
_fc_props.select_company_error = 'Molimo odaberite kompaniju';
_fc_props.audible = 'Čujno';
_fc_props.deleted_master_data_successfully = 'Glavni podaci uspješno izbrisani';
_fc_props.cloud_dvir__units_miles_abbr = 'MI';
_fc_props.cloud_dvir__units_kilometers_abbr = 'KM';
_fc_props.create_hauler_order = 'Kreiraj narudžbu za prijevoz';
_fc_props.send_gps = 'Pošalji GPS';
_fc_props.cloud_dvir__search_results = 'Rezultati pretrage';
_fc_props.cloud_dvir__advanced_filter = 'Napredni filter';
_fc_props.preload = 'Prethodno učitavanje';
_fc_props.job_name = 'Naziv posla';
_fc_props.delivery_address = 'Adresa za dostavu';
_fc_props.total_water_added = 'Ukupno dodane vode';
_fc_props.total_customer_water_added = 'Ukupno dodane vode za potrošače';
_fc_props.concrete_volume = 'Volumen betona';
_fc_props.water_events_and_volume = 'Vodni događaji i količina';
_fc_props.menu.reports.title.water_events_and_volume = 'Vodni događaji i količina';
_fc_props.menu.reports.description = {};
_fc_props.menu.reports.description.water_events_and_volume = 'Pogledajte dodanu vodu za tikete u različitim statusima i grupama';
_fc_props.returned_concrete_volume = 'Vraćena količina betona';
_fc_props.customer_water_added = 'Kupac je dodao vodu';
_fc_props.averages_and_totals = 'Prosjeci i ukupni iznosi';
_fc_props.preload_loading = 'Učitavanje prethodnog opterećenja';
_fc_props.preload_loaded = 'Prethodno učitavanje učitano';
_fc_props.send = 'Pošalji';
_fc_props.deliveries_iframe_url = 'URL IFrame-a za isporuke';
_fc_props.bulk_ticket_completion = 'Popunjavanje grupnih karata';
_fc_props.ticket_type = 'Vrsta karte';
_fc_props.complete_tickets = 'Kompletne karte';
_fc_props.tickets_found = 'Pronađene karte/karte';
_fc_props.include_preload = 'Uključi prethodno učitavanje';
_fc_props.exclude_preload = 'Isključi prethodno učitavanje';
_fc_props.selected_tickets = 'Odabrane ulaznice';
_fc_props.are_you_sure_you_want_to_complete_selected_tickets = 'Jeste li sigurni da želite dovršiti odabrane tikete?';
_fc_props.completing_tickets = 'Završavanje_karata';
_fc_props.some_tickets_failed_to_complete = 'Neke karte nisu uspjele biti dovršene';
_fc_props.bulk_ticket_complete_failed = 'Grupna prijava nije uspjela';
_fc_props.ticket_management = 'Upravljanje ulaznicama';
_fc_props.invalid_url_for_deliveries = 'Nevažeći URL za dostave';
_fc_props.menu_dvir_title_translations = 'Prijevodi';
_fc_props.cloud_dvir__dvir_translation = 'Prijevod';
_fc_props.template = 'Predložak';
_fc_props.menu_dvir_title_admin_translations = 'Prijevodi';
_fc_props.menu.dvir.description.translations = 'Pogledajte DVIR prijevode';
_fc_props.cloud_dvir__driver_review = 'Recenzija vozača';
_fc_props.cloud_dvir__mechanic_review = 'Pregled mehaničara';
_fc_props.cloud_dvir__driver_approval = 'Odobrenje vozača';
_fc_props.cloud_dvir__dvir_event_type = 'Vrsta DVIR događaja';
_fc_props.cloud_dvir__option_print_signed = 'Potpisano štampano izdanje';
_fc_props.deliveries_cloud_auth_enabled = 'Koristite Cloud Authentication za isporuke';
_fc_props.deliveries_host_name = 'Naziv hosta za isporuke';
_fc_props.cloud_dvir__option_event_history = 'Historija događaja';
_fc_props.ticketed_plant = 'Postrojenje s kaznama';
_fc_props.cloud_dvir__all_notes_and_photos_will_be_removed = 'Sve bilješke i fotografije bit će uklonjene';
_fc_props.cloud_dvir__continue = 'Nastavi';
_fc_props.cloud_dvir__cancel = 'Otkaži';
_fc_props.engine_diagnostic_canbaudrate_1 = 'MOŽE 1';
_fc_props.engine_diagnostic_canbaudrate_2 = 'MOŽE 2';
_fc_props.attached = 'Priloženo';
_fc_props.cloud_dvir__images = 'Slike';
_fc_props.settings.ticket_voided_status_change = 'Kada je karta poništena, promijenite status u';
_fc_props.ticket_voided_status_change_duplication_error = 'Promjena statusa poništene karte: Za svaku petlju statusa može se odabrati samo jedan status';
_fc_props.cloud_not_sending_events = 'ID entiteta u oblaku je postavljen, ali se događaji ne šalju u oblak';
_fc_props.set_ticket_integration_send_to_event_bus = 'U Postavkama integracije tiketa postavite slanje statusa/lokacije mostu događaja na "true"';
_fc_props.cloud_missing_loading = 'Integracija u oblak sa statusom UČITAVANJE koji nije postavljen u vrsti statusa';
_fc_props.cloud_assign_loading = 'Dodijelite značenje statusa UČITAVANJA kako bi se promijenio status učitavanja iz oblaka.';
_fc_props.cloud_missing_loaded = 'Integracija u oblak sa statusom LOADED koji nije postavljen u vrsti statusa';
_fc_props.cloud_assign_loaded = 'Dodijelite značenje statusa LOADED kako bi se dogodila promjena statusa učitavanja iz oblaka';
_fc_props.employee_no_valid_type = 'Zaposlenici bez dodijeljenog važećeg tipa zaposlenika';
_fc_props.employee_assign_valid_type = 'Provjerite da li svi zaposleni imaju dodijeljen važeći tip zaposlenika';
_fc_props.employee_no_valid_home_plant = 'Zaposleni bez dodijeljene važeće matične biljke';
_fc_props.employee_assign_valid_home_plant = 'Provjerite da li svi zaposleni imaju dodijeljenu kućnu biljku';
_fc_props.employee_dup_alt_num = 'Zaposlenici s dupliciranim alternativnim brojem zaposlenika';
_fc_props.employee_fix_dup_alt_num = 'Provjerite da li svi zaposleni imaju jedinstveni alternativni broj zaposlenika';
_fc_props.employee_type_no_default = 'Nema zadane vrste zaposlenika';
_fc_props.employee_type_assign_default = 'Postavite zadanu vrstu zaposlenika';
_fc_props.equipment_type_no_default = 'Nema zadane vrste opreme';
_fc_props.equipment_type_assign_default = 'Postavite zadanu vrstu opreme';
_fc_props.equipment_type_not_used = 'Nedodijeljene vrste opreme';
_fc_props.equipment_type_assign_not_used = 'Uklonite nekorištene tipove opreme';
_fc_props.equipment_no_valid_type = 'Oprema bez dodijeljenog važećeg tipa opreme';
_fc_props.equipment_assign_valid_type = 'Provjerite da li je svoj opremi dodijeljen važeći tip opreme';
_fc_props.equipment_no_valid_home_plant = 'Oprema bez dodijeljene važeće kućne elektrane';
_fc_props.equipment_assign_valid_home_plant = 'Provjerite da li sva oprema ima dodijeljenu matičnu elektranu';
_fc_props.equipment_no_valid_last_plant = 'Oprema bez važećeg dodijeljenog posljednjeg postrojenja';
_fc_props.equipment_assign_valid_last_plant = 'Provjerite da li je svoj opremi dodijeljen posljednji pogon';
_fc_props.equipment_dup_interface_num = 'Oprema sa duplim brojevima interfejsa';
_fc_props.equipment_fix_dup_interface_num = 'Provjerite da li sva oprema ima jedinstveni broj interfejsa';
_fc_props.equipment_no_vin = 'Oprema sa Cloud DVIR-om, ali bez VIN-a';
_fc_props.equipment_assign_vin = 'Ažurirajte opremu da biste dobili VIN';
_fc_props.equipment_probe_no_drum_type = 'Oprema s licencom za sondu, ali bez tipa bubnja';
_fc_props.equipment_probe_assign_drum_type = 'Ažurirajte opremu da ima tip bubnja';
_fc_props.equipment_drs_no_drum_type = 'Oprema sa senzorom rotacije bubnja, ali bez tipa bubnja';
_fc_props.equipment_drs_assign_drum_type = 'Ažurirajte opremu da ima tip bubnja';
_fc_props.equipment_ed_no_config = 'Oprema s licencom za dijagnostiku motora i bez konfiguracije';
_fc_props.equipment_ed_assign_no_config = 'Ažurirajte opremu kako biste imali konfiguraciju dijagnostike motora';
_fc_props.plant_no_dispatch_group = 'Postrojenja bez grupe za otpremu';
_fc_props.plant_assign_dispatch_group = 'Dodijelite biljke postojećim grupama za otpremu ili ponovo sačuvajte biljke da biste im dodijelili grupe za otpremu';
_fc_props.plant_dup_num = 'Biljka s dupliciranim brojevima biljaka';
_fc_props.plant_fix_dup_num = 'Provjerite da li sve fabrike imaju jedinstvene brojeve';
_fc_props.plant_dup_interface_num = 'Postrojenje sa duplim brojevima interfejsa';
_fc_props.plant_fix_dup_interface_num = 'Provjerite da li sve elektrane imaju jedinstveni broj interfejsa';
_fc_props.status_types_no_default_hotspot_type = 'Tipovi statusa kojima nedostaje zadani tip vruće tačke';
_fc_props.status_types_assign_default_hotspot_type = 'Postavite zadanu vrstu vruće tačke za svaku vrstu statusa';
_fc_props.hotspot_type_no_valid_enter_status = 'Tip vruće tačke unesite status više ne postoji';
_fc_props.hotspot_type_assign_valid_enter_status = 'Ažurirajte tip vruće tačke da ima važeći status unosa ili nijedan';
_fc_props.hotspot_type_no_valid_exit_status = 'Vrsta vruće tačke izlaza Status više ne postoji';
_fc_props.hotspot_type_assign_valid_exit_status = 'Ažurirajte tip vruće tačke da ima važeći status izlaza ili nijedan';
_fc_props.hotspot_type_not_usable = 'Tip vruće tačke postoji za tip statusa koji nije dodijeljen nijednom tipu opreme';
_fc_props.hotspot_type_fix_not_usable = 'Potvrdite upotrebu tipa vruće tačke. Ako se kreiraju vruće tačke ovog tipa, neće se pojaviti na mapi.';
_fc_props.hotspot_invalid_hotspot_type = 'Trajnoj pristupnoj tački nedostaje tip pristupne tačke';
_fc_props.hotspot_assign_hotspot_type = 'Ažurirajte vruću tačku da ima važeći tip vruće tačke';
_fc_props.plant_hotspot_conflict = 'Vruća tačka biljke ima konfliktni zadatak biljke';
_fc_props.plant_hotspot_fix_conflict = 'Postrojenje dodijeljeno postrojenju se razlikuje od postrojenja dodijeljenog na dodjeli tiketa, provjerite dodjelu postrojenja na vrućoj tački, možda će biti potrebno ponovo kreirati vruću tačku postrojenja da bi se riješio problem.';
_fc_props.plant_hotspot_restricted = 'Vruća tačka biljke je ograničena za određene karte';
_fc_props.plant_hotspot_fix_restricted = 'Vruća tačka biljke je ograničena za određene tikete, potrebno je ponovo kreirati vruću tačku biljke da bi se riješio problem.';
_fc_props.status_type_not_used = 'Vrsta statusa nije dodijeljena nijednoj vrsti opreme';
_fc_props.status_type_fix_not_used = 'Preporučuje se brisanje vrste statusa ako nije potrebna';
_fc_props.status_type_no_first = 'Nedostaje tip statusa Prvi status';
_fc_props.status_type_fix_no_first = 'Dodijelite prvi status vrsti statusa';
_fc_props.status_type_no_last = 'Nedostaje tip statusa Posljednji status';
_fc_props.status_type_fix_no_last = 'Dodijelite posljednji status vrsti statusa';
_fc_props.question_no_input_format = 'Pitanje nedostaje u formatu unosa';
_fc_props.question_assign_input_format = 'Dodijelite format pitanju';
_fc_props.ticket_no_concrete_product = 'Tiket za DRS ili sondu i nedostajuća kubna jarda ili kubni metar mjerne jedinice na proizvodu';
_fc_props.ticket_fix_no_concrete_product = 'Provjerite izvor tiketa i potvrdite da integracija šalje ispravnu jedinicu mjere';
_fc_props.ticket_preload_no_status_meaning = 'Prethodno učitane karte, ali nedostaje status prethodnog učitavanja Značenja';
_fc_props.ticket_preload_assign_status_meaning = 'Značenja statusa podešavanja za predučitavanje tiketa';
_fc_props.question_setup_no_end_miles = 'Postavljanje pitanja samo za početne milje';
_fc_props.question_setup_assign_end_miles = 'Ažurirajte postavke pitanja kako biste uključili i početne i završne milje';
_fc_props.question_setup_no_begin_miles = 'Postavljene su samo završne milje u postavkama pitanja';
_fc_props.question_setup_no_end_hours = 'Postavljeni su samo početni sati za postavljanje pitanja';
_fc_props.question_setup_assign_end_hours = 'Ažurirajte postavke pitanja kako biste uključili i početne i završne sate';
_fc_props.question_setup_no_begin_hours = 'Postavljeno je vrijeme završetka samo za postavljanje pitanja';
_fc_props.question_setup_no_last_plant = 'Postavljanje pitanja ne postavlja posljednju fabriku za opremu';
_fc_props.question_setup_assign_last_plant = 'Ažuriraj postavke pitanja kako bi uključio/la postavku Posljednje postrojenje za opremu';
_fc_props.device_not_used = 'Aktivni uređaj nije korišten u posljednjih 6 mjeseci';
_fc_props.device_delete_not_used = 'Provjera uređaja je i dalje potrebna';
_fc_props.cloud_integration = 'Integracija u oblak';
_fc_props.user_not_used = 'Korisnici sajta se nisu prijavili više od 6 mjeseci';
_fc_props.user_delete_not_used = 'Uklonite korisnike koji se ne prijavljuju';
_fc_props.no_configuration_errors = 'Nema grešaka u konfiguraciji';
_fc_props.configuration_error_summary = 'Sažetak konfiguracije';
_fc_props.configuration_errors = 'Konfiguracija';
_fc_props.question_setup = 'Postavljanje pitanja';
_fc_props.plant_no_default = 'Nema zadane biljke';
_fc_props.plant_assign_default = 'Postavite zadanu biljku';
_fc_props.master_data_error_logs = 'Zapisnici grešaka glavnih podataka';
_fc_props.master_data_error_logs_fetch_failed = 'Preuzimanje zapisnika o greškama glavnih podataka nije uspjelo';
_fc_props.equipment_flow_meter_no_pulse = 'Oprema ima mjerač protoka, ali nema volumen po impulsu';
_fc_props.equipment_flow_meter_fix_no_pulse = 'Dodijelite volumen po impulsu za mjerač protoka na opremi';
_fc_props.equipment_flow_meter_no_unit = 'Oprema ima mjerač protoka, ali nije odabrana jedinica za vodu';
_fc_props.equipment_flow_meter_fix_no_unit = 'Dodijelite jedinicu vode za mjerač protoka na opremi';
_fc_props.warn = 'Upozorenje';
_fc_props.security = 'Sigurnost';
_fc_props.error_validating_master_data_entity_not_found = 'Greška prilikom validacije glavnih podataka, entitet nije pronađen';
_fc_props.device_message_queue_not_assigned = 'device_message_queue_id ili device_message_canary_queue_id nije dodijeljen u database_server za hostname';
_fc_props.device_message_queue_not_assigned_resolution = 'Potreban je važeći device_message_queue_id i device_message_canary_queue_id u database_server';
_fc_props.talk_queue_not_assigned = 'talk_queue_id ili talk_canary_queue_id nije dodijeljen u database_server za hostname';
_fc_props.talk_queue_not_assigned_resolution = 'Potreban je važeći talk_queue_id i talk_canary_queue_id u database_server';
_fc_props.device_message_queue_dne = 'device_message_queue_id ne postoji za database_server_id';
_fc_props.device_message_queue_dne_resolution = 'Potreban je važeći device_message_queue_id za tabelu database_server';
_fc_props.device_message_canary_queue_dne = 'device_message_canary_queue_id ne postoji za database_server_id';
_fc_props.device_message_canary_queue_dne_resolution = 'Potreban je važeći device_message_canary_queue_id za tabelu database_server';
_fc_props.talk_queue_id_dne = 'ID_reda_za_razgovor ne postoji za ID_servera_database';
_fc_props.talk_queue_id_dne_resolution = 'Potreban je važeći talk_queue_id za tabelu database_server';
_fc_props.talk_canary_queue_id_dne = 'talk_canary_queue_id ne postoji za database_server_id';
_fc_props.talk_canary_queue_id_dne_resolution = 'Potreban je važeći talk_canary_queue_id za tabelu database_server';
_fc_props.device_message_queue_no_default = 'device_message_queue nedostaje zadana vrijednost';
_fc_props.device_message_queue_no_default_resolution = 'Dodijelite zadanu vrijednost u device_message_queue';
_fc_props.message_queue_url_dne = 'message_queue_url je null u device_message_queue';
_fc_props.message_queue_url_dne_resolution = 'Potreban je važeći message_queue_url u device_message_queue';
_fc_props.talk_queue_url_dne = 'talk_queue_url je null u device_message_queue';
_fc_props.talk_queue_url_dne_resolution = 'Potreban je važeći talk_queue_url u device_message_queue';
_fc_props.database_server_id_dne = 'database_server_id ne postoji za kompaniju';
_fc_props.database_server_id_dne_resolution = 'Potreban je važeći database_server_id u tabeli database_server';
_fc_props.dbname_assigned_dne = 'Naziv baze podataka dodijeljen korisnicima, ali kompanija ne postoji';
_fc_props.dbname_assigned_dne_resolution = 'Ukloni iz zapisa iz korisničke_baze podataka gdje naziv_baze podataka ne postoji';
_fc_props.canary_totals = 'Ukupni rezultati za Kanare';
_fc_props.failed_to_find_trackit_environment = 'Nije pronađen TrackItEnvironment';
_fc_props.failed_to_find_trackit_environment_resolution = 'Naziv hosta najvjerovatnije nije mapiran u TrackItEnvironmentu';
_fc_props.quartz_jobs_not_scheduled = 'Nedostajući poslovi iz kvarca';
_fc_props.quartz_jobs_not_scheduled_resolution = 'Zakažite nedostajuće poslove';
_fc_props.database_dne_for_company = 'Baza podataka ne postoji za kompaniju';
_fc_props.database_dne_for_company_resolution = 'Uklonite kompaniju iz tabele kompanija, kao i iz tabele korisnika_db';
_fc_props.deliveries_not_using_cloud_auth = 'Isporuke koje ne koriste autentifikaciju u oblaku';
_fc_props.deliveries_not_using_cloud_auth_resolution = 'Omogućite autentifikaciju u oblaku za isporuke u Postavkama integracije karata';
_fc_props.talk_using_quartz_scheduler = 'Talk koristi Quartz Scheduler';
_fc_props.talk_using_quartz_scheduler_resolution = 'Omogućite Korištenje AWS-a za razgovor u postavkama web-mjesta';
_fc_props.data_migration_scheduled_and_shouldnt = 'Migracija podataka je planirana i ne bi trebala biti';
_fc_props.data_migration_scheduled_and_shouldnt_resolution = 'Onemogućite kvarcni zadatak migracije podataka';
_fc_props.data_migration_not_scheduled = 'Migracija podataka nije planirana i trebala bi biti';
_fc_props.data_migration_not_scheduled_resolution = 'Omogući kvarcni zadatak migracije podataka';
_fc_props.data_migration_not_allowed = 'Migracija podataka nije dozvoljena na';
_fc_props.data_migration_allowed_on = 'Migracija podataka je dozvoljena';
_fc_props.enable_data_migration = 'Omogućite migraciju podataka za svaku kompaniju';
_fc_props.disable_data_migration = 'Onemogućite migraciju podataka za svaku kompaniju';
_fc_props.delayed_jobs_resolution = 'Ponovno kreiranje okidača, brisanje okidača ili ponovno pokretanje QuartzManagera';
_fc_props.environment_setup = 'Sažetak okruženja';
_fc_props.deprecated = 'Zastarjelo';
_fc_props.quartz_scheduler = 'Kvarcni planer';
_fc_props.device_queues = 'Redovi čekanja uređaja';
_fc_props.data_migration = 'Migracija podataka';
_fc_props.delayed_jobs = 'Odloženi poslovi';
_fc_props.hide_find_truck_menu_option = 'Sakrij opciju menija „Pronađi kamion“';
_fc_props.configuration_audit_info = 'Informacije o reviziji konfiguracije';
_fc_props.the_master_data_is_not_enabled_yet = 'Glavni podaci još nisu omogućeni';
_fc_props.the_master_data_enablement_audit_info = 'Glavni podaci su {0} od strane korisnika';
_fc_props.on_lower = 'na';
_fc_props.enabled_lower = 'omogućeno';
_fc_props.disabled_lower = 'onesposobljen';
_fc_props.mechanic_updated_successfully = 'Mehaničar uspješno ažuriran.';
_fc_props.no_audit_record = 'Nema dostupnih revizorskih zapisa.';
_fc_props._7_years = '7 godina (Arhiva)';
_fc_props.retention_continue = 'Nastavi';
_fc_props.retention_save_confirm_message = 'Ovo će uticati na količinu podataka pohranjenih na serveru i svi uklonjeni podaci NE MOGU SE OPORAVITI. Želite li nastaviti?';
_fc_props.cloud_dvir__uom_change_confirmation_title = 'Potvrdite jedinice i vrijednosti brojača kilometara';
_fc_props.cloud_dvir__uom_change_confirmation = 'Trenutna vrijednost brojača kilometara je {{engineValue}} {{engineUom}}, a unesena vrijednost brojača kilometara je {{fromValue}} {{fromUom}}. Je li ovo tačno?';

export default _fc_props;
